import { ClienteLink } from "./EntityLink";
import Cronoprogramma from "./Cronoprogramma";
import ManutenzioneTab from "./ManutenzioneTab";
import SopralluogoTab from "./SopralluogoTab";
import NoteCommessa from "./NoteCommessa";
import RegistroInterventi from "./RegistroInterventi";
import RichiestaCommercialeTab from "./RichiestaCommercialeTab";
import RelazioneFinaleModal from "./RelazioneFinaleModal";
import AttivitaExtraTab from "./AttivitaExtraTab";
import CabinaDiRegiaTab from "./CabinaDiRegiaTab";
import PersonalizzaCommessaMenu from "./PersonalizzaCommessaMenu";
import { useCanSee } from "../hooks/useCanSee";

// Reversibilità richiesta esplicitamente: un solo interruttore per tornare al vecchio
// comportamento (12 bottoni ON/OFF separati in testata) se il nuovo pannello unico non
// dovesse convincere — nessun altro codice da toccare, solo questa riga.
const USA_MENU_UNIFICATO_COMMESSA = true;
import { generaRelazioneFinale } from "../utils/relazioneFinaleCommessa";
import ComputoSALTab from "./ComputoSALTab";
import DDTTab from "./DDTTab";
import DDTIngressoTab from "./DDTIngressoTab";
import ComunicazioniTab from "./ComunicazioniTab";
import ReportCommessaTab from "./ReportCommessaTab";
import GiornaleCantiere from "./GiornaleCantiere";
import OrdineCaviTab from "./OrdineCaviTab";
import React, { useState, useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { confirm } from "../utils/confirm";
import { messaggioErrore } from "../utils/erroriUtente";
import { Plus, ChevronDown, ChevronRight, MoreHorizontal, Settings2, Trash2, Edit2, X, CheckCircle, Calendar, User, Share2, Archive, MoreVertical, FileText } from "lucide-react";
import RichiestaFatturazioneModal from "./RichiestaFatturazioneModal";
import { collection, onSnapshot, addDoc, updateDoc, deleteDoc, doc, serverTimestamp, query, where, orderBy, getDocs, getDoc, setDoc } from "firebase/firestore";
import { logEvento, TIPI_EVENTO } from "../utils/logEvento";
import SquadraEditor, { squadraTotale, normalizzaSquadra } from "./SquadraEditor";
import EsecuzioneCommessaEditor from "./EsecuzioneCommessaEditor";
import { SelettoreSede, RigaSede } from "./SediCliente";
import { descrizioneSede, sedeLavori } from "../utils/sediCliente";
import { tipoEsecuzione as leggiTipoEsecuzione, etichettaSquadra, impreseDaSalvare, descrizioneEsecuzione } from "../utils/esecuzioneCommessa";
import { logModifica, CAMPI_LABEL } from "../utils/logModifica";
import { isNoleggioAttivo, TIPI_MEZZO_OPERA, toLocalDateStr } from "../utils/noleggiUtils";
import { db } from "../firebase";
import { parseValutaItaliana, formatValutaItaliana } from "../utils/clienteHelpers";
import ControlloEconomico from "./ControlloEconomico";
import RichiestaMaterialiTab from "./RichiestaMaterialiTab";
import RichiediNFTab from "./RichiediNFTab";
import RelazioniCommessaWidget from "./RelazioniCommessaWidget";

// ── Variabili globali modulo per drag&drop task ───────────────────────────────
// Usare variabili globali evita problemi di propagazione eventi tra componenti
let _dragTaskId = null;
let _dragTaskSectionId = null;
// ─────────────────────────────────────────────────────────────────────────────
import RapportiniTab from "./RapportiniTab";

// ── ChiudiCommessaModal ──────────────────────────────────────────────────────
function ChiudiCommessaModal({ projectId, projectData, organizationId, currentUser, onClose, addToast }) {
  const [dataChiusura, setDataChiusura] = useState(toLocalDateStr(new Date()));
  const [motivazione, setMotivazione] = useState("");
  const [noteChiusura, setNoteChiusura] = useState("");
  const [attivitaAperte, setAttivitaAperte] = useState([]);
  const [noleggiAttiviCommessa, setNoleggiAttiviCommessa] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!projectId) return;
    getDocs(query(collection(db,"tasks"), where("projectId","==",projectId), where("organizationId","==",organizationId)))
      .then(snap => setAttivitaAperte(snap.docs.map(d=>d.data()).filter(t=>t.status!=="completed"&&t.status!=="completata")));
  }, [projectId]);

  // Blocco chiusura: eventuali mezzi d'opera a noleggio ancora attivi su questa commessa
  // vanno chiusi PRIMA di poter chiudere la commessa — altrimenti il costo continuerebbe
  // a crescere su una commessa ormai chiusa, senza che nessuno lo veda più (vedi Registro Noleggi).
  useEffect(() => {
    if (!projectId) return;
    getDocs(query(collection(db,"noleggi"), where("projectId","==",projectId), where("orgId","==",organizationId), where("categoria","==","mezzo_opera")))
      .then(snap => setNoleggiAttiviCommessa(snap.docs.map(d=>({id:d.id,...d.data()})).filter(isNoleggioAttivo)));
  }, [projectId]);

  const inp = { padding:"8px 10px", border:"1px solid #e5e7eb", borderRadius:7, fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%", boxSizing:"border-box" };
  const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

  const chiudi = async () => {
    if (!motivazione.trim()) { addToast("Inserisci la motivazione di chiusura","error"); return; }
    if (noleggiAttiviCommessa.length>0) { addToast("Chiudi prima i noleggi mezzi d'opera ancora attivi","error"); return; }
    setSaving(true);
    // La Relazione Finale si genera da sola in questo momento, come documento definitivo
    // (non provvisorio) — passiamo statoCommessa già "chiusa" perché il motore lo capisca,
    // anche se il salvataggio vero avviene subito dopo.
    let relazioneFinaleChiusura = null;
    try {
      relazioneFinaleChiusura = await generaRelazioneFinale({ projectId, projectData: {...projectData, statoCommessa:"chiusa", motivazioneChiusura:motivazione, dataChiusura}, orgId: organizationId });
    } catch (err) {
      console.error("Errore generazione relazione finale commessa:", err); // non blocca la chiusura se fallisce
    }
    // W422: se il salvataggio non riesce lo si dice (prima l'errore restava invisibile e
    // la finestra rimaneva ferma su «salvataggio»)
    try { await updateDoc(doc(db,"projects",projectId), {
      statoCommessa:"chiusa", dataChiusura,
      motivazioneChiusura:motivazione, noteChiusura,
      chiusaUid:currentUser?.uid, chiusaNome:currentUser?.displayName||"",
      chiusaAt:serverTimestamp(),
      ...(relazioneFinaleChiusura ? {relazioneFinaleChiusura} : {}),
    }); } catch (err) { addToast(messaggioErrore(err, "chiudere la commessa"), "error"); setSaving(false); return; }
    logModifica({ orgId:organizationId, uid:currentUser?.uid||"", nomeUtente:currentUser?.displayName||"",
      sezione:"commesse", refId:projectId, refNome:projectData?.name||"",
      campo:"statoCommessa", campoLabel:"Stato commessa", before:"Attiva", after:"Chiusa",
      projectId, projectName:projectData?.name||"" });
    logEvento({ orgId:organizationId, tipo:"COMMESSA_CHIUSA",
      projectId, projectName:projectData?.name||"",
      uid:currentUser?.uid, nomeUtente:currentUser?.displayName||"", dettaglio:motivazione });
    addToast("Commessa chiusa ✅","success");
    setSaving(false); onClose();
  };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:520}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
          <h3 style={{fontSize:15,fontWeight:800,color:"#dc2626",margin:0}}>🔒 Chiudi commessa</h3>
          <button className="btn-icon" onClick={onClose}><X size={15}/></button>
        </div>
        <div style={{background:"#fef2f2",border:"1px solid #fca5a5",borderRadius:8,padding:"10px 14px",marginBottom:16}}>
          <div style={{fontSize:13,fontWeight:700,color:"#dc2626"}}>{projectData?.name}</div>
          <div style={{fontSize:11,color:"#9ca3af",marginTop:2}}>
            {projectData?.codiceCommessa&&`[${projectData.codiceCommessa}] · `}Responsabile: {projectData?.responsabileNome||"—"}
          </div>
        </div>
        {noleggiAttiviCommessa.length>0&&(
          <div style={{background:"#fef2f2",border:"1px solid #fca5a5",borderRadius:8,padding:"10px 14px",marginBottom:16}}>
            <div style={{fontSize:12,fontWeight:700,color:"#dc2626",marginBottom:4}}>🏗️ {noleggiAttiviCommessa.length} noleggio/i mezzi d'opera ancora attivo/i</div>
            <div style={{fontSize:11,color:"#991b1b",marginBottom:2}}>
              {noleggiAttiviCommessa.map(n=>`${TIPI_MEZZO_OPERA[n.tipo]?.label||n.tipo} (${n.fornitore})`).join(", ")}
            </div>
            <div style={{fontSize:11,color:"#78350f"}}>Chiudili prima dal Registro e gestione noleggi (o dal Controllo Economico di questa commessa) — altrimenti il costo continuerebbe a crescere su una commessa chiusa.</div>
          </div>
        )}
        {attivitaAperte.length>0&&(
          <div style={{background:"#fef3c7",border:"1px solid #fde68a",borderRadius:8,padding:"10px 14px",marginBottom:16}}>
            <div style={{fontSize:12,fontWeight:700,color:"#92400e",marginBottom:4}}>⚠️ {attivitaAperte.length} attività ancora aperte</div>
            <div style={{fontSize:11,color:"#78350f"}}>La chiusura non elimina le attività. Saranno visibili riaprendo la commessa.</div>
          </div>
        )}
        <div style={{marginBottom:12}}>
          <label style={lbl}>Data di chiusura *</label>
          <input type="date" style={inp} value={dataChiusura} onChange={e=>setDataChiusura(e.target.value)}/>
        </div>
        <div style={{marginBottom:12}}>
          <label style={lbl}>Motivazione * <span style={{color:"#9ca3af",fontWeight:400}}>(obbligatoria)</span></label>
          <select style={inp} value={motivazione} onChange={e=>setMotivazione(e.target.value)}>
            <option value="">— Seleziona —</option>
            <option value="Lavori completati">✅ Lavori completati</option>
            <option value="Contratto concluso">📋 Contratto concluso</option>
            <option value="Collaudo superato">🏗️ Collaudo superato</option>
            <option value="Rescissione contratto">⛔ Rescissione contratto</option>
            <option value="Sospensione lavori">⏸️ Sospensione lavori</option>
            <option value="Altra motivazione">📝 Altra motivazione</option>
          </select>
        </div>
        <div style={{marginBottom:16}}>
          <label style={lbl}>Note di chiusura</label>
          <textarea value={noteChiusura} onChange={e=>setNoteChiusura(e.target.value)}
            placeholder="Stato finale lavori, pendenze, importo finale, note per il file..."
            style={{...inp,minHeight:80,resize:"vertical"}}/>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button className="btn btn-secondary" onClick={onClose}>Annulla</button>
          <button onClick={chiudi} disabled={saving||!motivazione||noleggiAttiviCommessa.length>0}
            style={{padding:"8px 20px",border:"none",borderRadius:8,
              background:(!motivazione||noleggiAttiviCommessa.length>0)?"#e5e7eb":"#dc2626",color:(!motivazione||noleggiAttiviCommessa.length>0)?"#9ca3af":"#fff",
              fontSize:13,fontWeight:700,cursor:(!motivazione||noleggiAttiviCommessa.length>0)?"not-allowed":"pointer",fontFamily:"'Inter',sans-serif"}}>
            {saving?"...":noleggiAttiviCommessa.length>0?"🔒 Chiudi prima i noleggi":"🔒 Chiudi commessa"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── RiapriCommessaModal ───────────────────────────────────────────────────────
function RiapriCommessaModal({ projectId, projectData, organizationId, currentUser, onClose, addToast }) {
  const [motivazione, setMotivazione] = useState("");
  const [saving, setSaving] = useState(false);
  const inp = { padding:"8px 10px", border:"1px solid #e5e7eb", borderRadius:7, fontSize:13, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%", boxSizing:"border-box" };
  const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

  const riapri = async () => {
    if (!motivazione.trim()) { addToast("Inserisci la motivazione di riapertura","error"); return; }
    setSaving(true);
    await updateDoc(doc(db,"projects",projectId), {
      statoCommessa:"attiva",
      dataRiapertura:toLocalDateStr(new Date()),
      motivazioneRiapertura:motivazione,
      riapritoUid:currentUser?.uid, riapritoNome:currentUser?.displayName||"",
      riapritoAt:serverTimestamp(),
    });
    logModifica({ orgId:organizationId, uid:currentUser?.uid||"", nomeUtente:currentUser?.displayName||"",
      sezione:"commesse", refId:projectId, refNome:projectData?.name||"",
      campo:"statoCommessa", campoLabel:"Stato commessa", before:"Chiusa", after:"Attiva",
      projectId, projectName:projectData?.name||"" });
    logEvento({ orgId:organizationId, tipo:"COMMESSA_RIAPERTA",
      projectId, projectName:projectData?.name||"",
      uid:currentUser?.uid, nomeUtente:currentUser?.displayName||"", dettaglio:motivazione });
    addToast("Commessa riaperta ✅","success");
    setSaving(false); onClose();
  };

  return (
    <div className="modal-overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:480}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
          <h3 style={{fontSize:15,fontWeight:800,color:"#059669",margin:0}}>🔓 Riapri commessa</h3>
          <button className="btn-icon" onClick={onClose}><X size={15}/></button>
        </div>
        <div style={{background:"#f0fdf4",border:"1px solid #86efac",borderRadius:8,padding:"10px 14px",marginBottom:16}}>
          <div style={{fontSize:13,fontWeight:700,color:"#065f46"}}>{projectData?.name}</div>
          <div style={{fontSize:11,color:"#9ca3af",marginTop:2}}>
            Chiusa il: {projectData?.dataChiusura?new Date(projectData.dataChiusura+"T00:00:00").toLocaleDateString("it-IT"):"—"}
            {projectData?.chiusaNome&&` · da ${projectData.chiusaNome}`}
          </div>
          {projectData?.motivazioneChiusura&&(
            <div style={{fontSize:11,color:"#374151",marginTop:4}}>Motivo: <strong>{projectData.motivazioneChiusura}</strong></div>
          )}
        </div>
        <div style={{marginBottom:16}}>
          <label style={lbl}>Motivazione riapertura * <span style={{color:"#9ca3af",fontWeight:400}}>(obbligatoria)</span></label>
          <textarea value={motivazione} onChange={e=>setMotivazione(e.target.value)}
            placeholder="Es. Variante in corso d'opera, lavori aggiuntivi richiesti dal committente..."
            style={{...inp,minHeight:80,resize:"vertical"}}/>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <button className="btn btn-secondary" onClick={onClose}>Annulla</button>
          <button onClick={riapri} disabled={saving||!motivazione}
            style={{padding:"8px 20px",border:"none",borderRadius:8,
              background:!motivazione?"#e5e7eb":"#059669",color:!motivazione?"#9ca3af":"#fff",
              fontSize:13,fontWeight:700,cursor:!motivazione?"not-allowed":"pointer",fontFamily:"'Inter',sans-serif"}}>
            {saving?"...":"🔓 Riapri commessa"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Form piano di carico inline ─────────────────────────────
function PianoCaricForm({ projectId, projectData, onSaved, onClose }) {
  const [form, setForm] = React.useState({
    dataInizio: projectData?.dataInizio||"",
    dataFine: projectData?.dataFine||"",
    oreGiornaliere: projectData?.oreGiornaliere||8,
  });
  const [squadra, setSquadra] = React.useState(()=>normalizzaSquadra(projectData));
  const [saving, setSaving] = React.useState(false);
  const { currentUser } = useAuth();
  const { addToast } = useToast();
  // Chi esegue i lavori (utils/esecuzioneCommessa.js)
  const [tipoEs, setTipoEs] = React.useState(()=>leggiTipoEsecuzione(projectData));
  const [sede, setSede] = React.useState(projectData?.sede || null);
  const [imprese, setImprese] = React.useState(()=>(projectData?.impreseEsterne||[]).map(i=>({...i, uominiGiorno: i.uominiGiorno ?? ""})));
  const cambiaTipoEs = (t) => {
    if (t==="subappalto" && tipoEs!=="subappalto" && squadra.length>1) {
      setSquadra([{livello:0}]); // resta 1 persona di presidio
      addToast(`Subappalto: la squadra interna passa da ${squadra.length} figure a 1 persona di presidio. Se non salvi, resta com'era.`, "info");
    }
    setTipoEs(t);
  };
  const etSquadra = etichettaSquadra(tipoEs);

  // Il piano incompleto non blocca il salvataggio (si può voler cambiare solo la sede):
  // resta l'avviso, e la commessa resta fuori dal Simulatore finché non è completo.
  const pianoCompleto = form.dataInizio && form.dataFine && squadra.length>0 && squadraTotale(squadra)>0;
  const canSave = true;

  const salva = async () => {
    if(!canSave) return;
    setSaving(true);
    try {
      const nuoveImprese = impreseDaSalvare(tipoEs, imprese);
      await updateDoc(doc(db,"projects",projectId),{
        dataInizio: form.dataInizio,
        dataFine: form.dataFine,
        oreGiornaliere: parseFloat(form.oreGiornaliere)||8,
        squadra,
        operaiNecessari: squadraTotale(squadra),
        livelloMin: squadra.length>0?Math.max(...squadra.map(r=>r.livello||0)):0,
        tipoEsecuzione: tipoEs,
        impreseEsterne: nuoveImprese,
        sede: sede || null,
        updatedAt: serverTimestamp(),
      });
      if (descrizioneSede(projectData?.sede) !== descrizioneSede(sede)) logModifica({ orgId: projectData?.organizationId, uid: currentUser?.uid||"", nomeUtente: currentUser?.displayName||"",
        sezione:"commesse", refId: projectId, refNome: projectData?.name||"", campo:"sede", campoLabel:"Sede dei lavori",
        before: descrizioneSede(projectData?.sede) || "—", after: descrizioneSede(sede) || "—", projectId, projectName: projectData?.name||"" });
      // Il cambio di chi esegue i lavori resta nel registro modifiche
      const prima = descrizioneEsecuzione(projectData), dopo = descrizioneEsecuzione({ tipoEsecuzione: tipoEs, impreseEsterne: nuoveImprese });
      if (prima !== dopo) logModifica({ orgId: projectData?.organizationId, uid: currentUser?.uid||"", nomeUtente: currentUser?.displayName||"",
        sezione:"commesse", refId: projectId, refNome: projectData?.name||"", campo:"tipoEsecuzione", campoLabel:"Chi esegue i lavori",
        before: prima, after: dopo, projectId, projectName: projectData?.name||"" });
      onSaved();
    } catch(err) { addToast(messaggioErrore(err, "salvare il piano di carico"),"error"); }
    setSaving(false);
  };

  const inp = {width:"100%",padding:"7px 10px",border:"1px solid #e5e7eb",borderRadius:8,fontSize:12,fontFamily:"'Inter',sans-serif",outline:"none",boxSizing:"border-box"};

  return (
    <div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:12}}>
        <div>
          <label style={{fontSize:11,fontWeight:700,color:"#374151",display:"block",marginBottom:4}}>Data inizio *</label>
          <input type="date" style={inp} value={form.dataInizio} onChange={e=>setForm(f=>({...f,dataInizio:e.target.value}))}/>
        </div>
        <div>
          <label style={{fontSize:11,fontWeight:700,color:"#374151",display:"block",marginBottom:4}}>Data fine *</label>
          <input type="date" style={inp} value={form.dataFine} onChange={e=>setForm(f=>({...f,dataFine:e.target.value}))}/>
        </div>
        <div style={{gridColumn:"1/-1"}}>
          <label style={{fontSize:11,fontWeight:700,color:"#374151",display:"block",marginBottom:4}}>Ore giornaliere per operaio</label>
          <select style={{...inp,width:"auto"}} value={form.oreGiornaliere} onChange={e=>setForm(f=>({...f,oreGiornaliere:e.target.value}))}>
            {[4,5,6,7,8,9,10].map(h=><option key={h} value={h}>{h}h</option>)}
          </select>
        </div>
      </div>
      <div style={{marginBottom:12}}>
        {!projectData?.senzaCliente && (
          <div style={{marginBottom:12}}>
            <SelettoreSede clienteId={projectData?.clienteId||""} value={sede} onChange={setSede} etichetta="📍 Sede dei lavori"/>
          </div>
        )}
        <label style={{fontSize:11,fontWeight:700,color:"#374151",display:"block",marginBottom:6}}>Chi esegue i lavori</label>
        <EsecuzioneCommessaEditor tipo={tipoEs} onTipo={cambiaTipoEs} imprese={imprese} onImprese={setImprese} compact={true}/>
      </div>
      <div style={{marginBottom:12}}>
        <label style={{fontSize:11,fontWeight:700,color:"#374151",display:"block",marginBottom:6}}>{etSquadra.titolo} *</label>
        {etSquadra.aiuto && <div style={{fontSize:10.5,color:"#9ca3af",marginBottom:6}}>{etSquadra.aiuto}</div>}
        <SquadraEditor squadra={squadra} onChange={setSquadra} compact={true}/>
      </div>
      {!pianoCompleto&&(
        <div style={{fontSize:11,color:"#d97706",marginBottom:12}}>⚠️ Per il Simulatore servono le date e almeno una figura professionale (puoi salvare lo stesso).</div>
      )}
      <div style={{display:"flex",gap:10,justifyContent:"flex-end"}}>
        <button onClick={onClose} style={{padding:"8px 16px",border:"1px solid #e5e7eb",borderRadius:8,background:"#fff",color:"#374151",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
          Annulla
        </button>
        <button onClick={salva} disabled={saving||!canSave}
          style={{padding:"8px 20px",border:"none",borderRadius:8,background:!canSave?"#d1d5db":"#7c3aed",color:"#fff",fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
          {saving?"Salvo...":"✅ Salva dati carico"}
        </button>
      </div>
    </div>
  );
}

// ── Timeline progetto ────────────────────────────────────────────────────────
function TimelineProgetto({ projectId, orgId }) {
  const [eventi, setEventi] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(()=>{
    if(!projectId||!orgId) return;
    return onSnapshot(
      query(collection(db,"eventi"),where("projectId","==",projectId),where("orgId","==",orgId)),
      snap=>{ 
        const list = snap.docs.map(d=>({id:d.id,...d.data()}));
        list.sort((a,b)=>(b.createdAt?.toMillis?.()??0)-(a.createdAt?.toMillis?.()??0));
        setEventi(list); setLoading(false); 
      }
    );
  },[projectId,orgId]);

  const EMOJI = {commesse:"📁",attivita:"✔️",clienti:"🏢",noteSpese:"💳",acquisti:"🛒",rapportini:"📋",presenze:"🕐",verbali:"📝",dipendenti:"👷",economia:"💰"};
  const PRIOCOL = {info:"#6b7280",medio:"#d97706",alto:"#ea580c",critico:"#dc2626"};

  if(loading) return <div style={{padding:40,textAlign:"center",color:"#9ca3af"}}>Caricamento...</div>;

  return (
    <div style={{padding:20}}>
      <h3 style={{fontSize:14,fontWeight:700,marginBottom:16,color:"#111827"}}>📡 Timeline commessa</h3>
      {eventi.length===0 ? (
        <div style={{textAlign:"center",padding:48,color:"#9ca3af"}}>
          <div style={{fontSize:32,marginBottom:12}}>📡</div>
          <div style={{fontSize:13}}>Nessun evento registrato per questa commessa.</div>
          <div style={{fontSize:11,marginTop:4}}>Gli eventi appariranno qui man mano che vengono registrati.</div>
        </div>
      ) : (
        <div style={{position:"relative"}}>
          <div style={{position:"absolute",left:18,top:0,bottom:0,width:2,background:"#e5e7eb"}}/>
          {eventi.map((ev,i)=>{
            const col = PRIOCOL[ev.priorita]||"#6b7280";
            const ts = ev.createdAt?.toDate?.();
            return (
              <div key={ev.id} style={{display:"flex",gap:12,marginBottom:14,position:"relative",zIndex:1}}>
                <div style={{width:36,height:36,borderRadius:"50%",background:"#fff",border:`2px solid ${col}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,flexShrink:0}}>
                  {EMOJI[ev.categoria]||"📌"}
                </div>
                <div style={{flex:1,background:"#fff",border:"1px solid #f3f4f6",borderRadius:8,padding:"8px 12px"}}>
                  <div style={{fontSize:12,fontWeight:700,color:"#111827"}}>{ev.titolo}</div>
                  {ev.descrizione&&<div style={{fontSize:11,color:"#6b7280",marginTop:1}}>{ev.descrizione}</div>}
                  <div style={{fontSize:10,color:"#9ca3af",marginTop:3,display:"flex",gap:8}}>
                    <span>👤 {ev.nomeUtente||"Sistema"}</span>
                    {ts&&<span>{ts.toLocaleDateString("it-IT")} {ts.toLocaleTimeString("it-IT",{hour:"2-digit",minute:"2-digit"})}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ── Gestione membri progetto ─────────────────────────────────────────────────
function MembriProgetto({ project, orgId, currentUser, isAdmin }) {
  const [utenti, setUtenti] = React.useState([]);
  const [saving, setSaving] = React.useState(false);
  const { addToast } = useToast();
  const membri = project?.membri || [];

  const canManage = isAdmin ||
    project?.createdBy === currentUser?.uid ||
    !!membri.find(m=>m.uid===currentUser?.uid&&m.ruolo==="responsabile");

  React.useEffect(()=>{
    if(!orgId) return;
    getDocs(query(collection(db,"users"),where("organizationId","==",orgId),where("enabled","==",true)))
      .then(snap=>setUtenti(snap.docs.map(d=>d.data()).sort((a,b)=>(a.displayName||"").localeCompare(b.displayName||"","it"))))
      .catch(err=>{
        console.error("Errore caricamento utenti (MembriProgetto):", err);
        addToast("Impossibile caricare l'elenco utenti: "+(err?.message||"errore sconosciuto"),"error");
      });
  },[orgId]);

  const toggleMembro = async (utente) => {
    if(!canManage) return;
    const esiste = membri.find(m=>m.uid===utente.uid);
    let nuovi;
    if(esiste){
      if(esiste.ruolo==="responsabile"&&membri.filter(m=>m.ruolo==="responsabile").length===1){
        addToast("Deve esserci almeno un Responsabile","error"); return;
      }
      nuovi = membri.filter(m=>m.uid!==utente.uid);
    } else {
      nuovi = [...membri, {uid:utente.uid, nome:utente.displayName, ruolo:"operativo"}];
    }
    setSaving(true);
    await updateDoc(doc(db,"projects",project.id),{ membri:nuovi, hasMembri:nuovi.length>0, updatedAt:serverTimestamp() });
    setSaving(false);
    addToast("Membri aggiornati ✅","success");
  };

  const cambiaRuolo = async (uid, ruolo) => {
    if(!canManage) return;
    const nuovi = membri.map(m=>m.uid===uid?{...m,ruolo}:m);
    await updateDoc(doc(db,"projects",project.id),{ membri:nuovi, updatedAt:serverTimestamp() });
  };

  // Cambia responsabile commessa con audit log
  const cambiaResponsabile = async (nuovoUid, nuovoNome) => {
    if (!nuovoUid || !nuovoNome) return;
    const vecchioNome = project?.responsabileNome || "—";
    await updateDoc(doc(db,"projects",project.id), {
      responsabileUid: nuovoUid,
      responsabileNome: nuovoNome,
    });
    logModifica({
      orgId: orgId, uid: currentUser?.uid, nomeUtente: currentUser?.displayName||"",
      sezione:"commesse", refId:project.id, refNome:project?.name||"",
      campo:"responsabile", campoLabel:"Responsabile commessa",
      before: vecchioNome, after: nuovoNome,
      projectId:project.id, projectName:project?.name||""
    });
    addToast(`Responsabile aggiornato: ${nuovoNome} ✅`,"success");
  };

  const RUOLI = {
    responsabile:{label:"Responsabile",col:"#7c3aed",bg:"#ede9fe"},
    operativo:{label:"Operativo",col:"#059669",bg:"#d1fae5"},

  };

  return (
    <div style={{padding:20}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
        <h3 style={{fontSize:14,fontWeight:700,color:"#111827"}}>👥 Membri del progetto</h3>
        {membri.length===0 && <span style={{fontSize:11,color:"#f59e0b",background:"#fef3c7",padding:"3px 10px",borderRadius:10}}>⚠️ Nessun membro — visibile a tutti</span>}
      </div>
      <div style={{display:"flex",gap:6,marginBottom:14,flexWrap:"wrap",fontSize:10,color:"#9ca3af"}}>
        {Object.entries(RUOLI).map(([k,v])=>(
          <span key={k} style={{fontWeight:700,padding:"2px 8px",borderRadius:10,background:v.bg,color:v.col}}>{v.label}</span>
        ))}
        <span style={{alignSelf:"center"}}>— Responsabile: gestisce · Operativo: solo sue attività</span>
      </div>
      <div style={{border:"1px solid #e5e7eb",borderRadius:10,overflow:"hidden"}}>
        {utenti.map((u,i)=>{
          const membro = membri.find(m=>m.uid===u.uid);
          const ruoloInfo = membro ? RUOLI[membro.ruolo] : null;
          return (
            <div key={u.uid} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderBottom:i<utenti.length-1?"1px solid #f3f4f6":"none",background:membro?"#faf5ff":"#fff"}}>
              <div style={{width:30,height:30,borderRadius:"50%",background:membro?"#7c3aed":"#e5e7eb",display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:membro?"#fff":"#9ca3af",flexShrink:0}}>
                {(u.displayName||"?").split(" ").map(s=>s[0]).join("").slice(0,2).toUpperCase()}
              </div>
              <span style={{flex:1,fontSize:13,fontWeight:membro?600:400,color:membro?"#111827":"#6b7280"}}>{u.displayName}</span>
              {membro && ruoloInfo && (
                canManage ? (
                  <select value={membro.ruolo} onChange={e=>cambiaRuolo(u.uid,e.target.value)}
                    style={{fontSize:11,padding:"3px 8px",border:`1px solid ${ruoloInfo.col}`,borderRadius:8,background:ruoloInfo.bg,color:ruoloInfo.col,fontWeight:700,fontFamily:"'Inter',sans-serif",outline:"none"}}>
                    <option value="responsabile">Responsabile</option>
                    <option value="operativo">Operativo</option>
                  </select>
                ) : (
                  <span style={{fontSize:11,fontWeight:700,padding:"2px 8px",borderRadius:8,background:ruoloInfo.bg,color:ruoloInfo.col}}>{ruoloInfo.label}</span>
                )
              )}
              {canManage && (
                <button onClick={()=>toggleMembro(u)} disabled={saving}
                  style={{padding:"3px 7px",border:`1px solid ${membro?"#fca5a5":"#e5e7eb"}`,borderRadius:7,background:membro?"#fee2e2":"#fff",color:membro?"#dc2626":"#374151",cursor:"pointer",fontSize:11,fontWeight:600,fontFamily:"'Inter',sans-serif"}}>
                  {membro?"Rimuovi":"Aggiungi"}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}

// Verbali collegati alla commessa
function VerbaliCommessa({ projectId, orgId, currentUserUid, isAdmin }) {
  const [verbali, setVerbali] = React.useState([]);
  const [verbaleOpen, setVerbaleOpen] = React.useState(null);
  React.useEffect(()=>{
    if(!orgId)return;
    return onSnapshot(query(collection(db,"verbali"),where("orgId","==",orgId)),snap=>{
      const tutti=snap.docs.map(d=>({id:d.id,...d.data()}));
      const collegati=tutti.filter(v=>(v.commesseCollegate||[]).find(c=>c.id===projectId));
      const visibili=collegati.filter(v=>{
        if(v.visibilita==="tutti"||isAdmin)return true;
        return (v.partecipanti||[]).find(p=>p.uid===currentUserUid);
      });
      visibili.sort((a,b)=>(b.data||"").localeCompare(a.data||""));
      setVerbali(visibili);
    });
  },[orgId,projectId,currentUserUid,isAdmin]);

  if(verbali.length===0)return(
    <div style={{padding:32,textAlign:"center",color:"#9ca3af",fontSize:13}}>
      Nessun verbale collegato a questa commessa.
    </div>
  );

  const STATI_V={bozza:{label:"Bozza",bg:"#f3f4f6",col:"#6b7280"},definitivo:{label:"Definitivo",bg:"#d1fae5",col:"#059669"},inviato:{label:"Inviato",bg:"#dbeafe",col:"#2563eb"}};

  return(
    <div style={{padding:16}}>
      {verbaleOpen&&(
        <div style={{background:"#fff",border:"1px solid #e5e7eb",borderRadius:10,padding:20,marginBottom:12}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:12}}>
            <h3 style={{fontSize:14,fontWeight:700,color:"#7c3aed"}}>{verbaleOpen.titolo}</h3>
            <button onClick={()=>setVerbaleOpen(null)} style={{background:"none",border:"none",cursor:"pointer",color:"#9ca3af"}}>✕</button>
          </div>
          <div style={{fontSize:12,color:"#6b7280",marginBottom:12}}>📅 {verbaleOpen.data?.split("-").reverse().join("/")} {verbaleOpen.luogo?`· 📍 ${verbaleOpen.luogo}`:""}</div>
          {verbaleOpen.ordineGiorno&&<div style={{marginBottom:10}}><div style={{fontSize:10,fontWeight:700,color:"#7c3aed",textTransform:"uppercase",marginBottom:4}}>Ordine del giorno</div><p style={{fontSize:12,color:"#374151",whiteSpace:"pre-wrap"}}>{verbaleOpen.ordineGiorno}</p></div>}
          {verbaleOpen.discussione&&<div style={{marginBottom:10}}><div style={{fontSize:10,fontWeight:700,color:"#7c3aed",textTransform:"uppercase",marginBottom:4}}>Discussione</div><p style={{fontSize:12,color:"#374151",whiteSpace:"pre-wrap"}}>{verbaleOpen.discussione}</p></div>}
          {verbaleOpen.decisioni&&<div style={{marginBottom:10}}><div style={{fontSize:10,fontWeight:700,color:"#7c3aed",textTransform:"uppercase",marginBottom:4}}>Decisioni</div><p style={{fontSize:12,color:"#374151",whiteSpace:"pre-wrap"}}>{verbaleOpen.decisioni}</p></div>}
          {(verbaleOpen.azioniDaFare||[]).length>0&&<div><div style={{fontSize:10,fontWeight:700,color:"#7c3aed",textTransform:"uppercase",marginBottom:4}}>Azioni da fare</div>
            {verbaleOpen.azioniDaFare.map((a,i)=><div key={i} style={{fontSize:12,padding:"4px 0",borderBottom:"1px solid #f3f4f6",color:"#374151"}}>• {a.descrizione} — <span style={{color:"#6b7280"}}>{a.assegnatoA||"—"}</span> entro {a.scadenza||"—"}</div>)}
          </div>}
        </div>
      )}
      {verbali.map(v=>{
        const st=STATI_V[v.stato]||STATI_V.bozza;
        return(
          <div key={v.id} style={{background:"#fff",border:"1px solid #e5e7eb",borderRadius:8,padding:"10px 14px",marginBottom:8,display:"flex",alignItems:"center",justifyContent:"space-between",gap:10}}>
            <div>
              <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:3}}>
                <span style={{fontSize:13,fontWeight:700,color:"#111827"}}>📄 {v.titolo}</span>
                <span style={{padding:"1px 7px",borderRadius:10,fontSize:10,fontWeight:700,background:st.bg,color:st.col}}>{st.label}</span>
              </div>
              <div style={{fontSize:11,color:"#6b7280"}}>📅 {v.data?.split("-").reverse().join("/")} {v.luogo?`· ${v.luogo}`:""}</div>
            </div>
            <button onClick={()=>setVerbaleOpen(verbaleOpen?.id===v.id?null:v)}
              style={{padding:"5px 12px",border:"1px solid #7c3aed",borderRadius:6,background:"#ede9fe",color:"#7c3aed",cursor:"pointer",fontSize:11,fontWeight:600,fontFamily:"'Inter',sans-serif",whiteSpace:"nowrap"}}>
              {verbaleOpen?.id===v.id?"Chiudi":"Leggi →"}
            </button>
          </div>
        );
      })}
    </div>
  );
}
import RegoleProgetto from "./RegoleProgetto";
import { useFeatures } from "../contexts/FeaturesContext";
import { useAuth } from "../contexts/AuthContext";
import { useOrg } from "../contexts/OrgContext";
import { useToast } from "../utils/Toast";
import { isTaskOverdue } from "../utils/taskHelpers";
import TaskDetailPanel from "./TaskDetailPanel";
import SubtaskDetailPanel from "./SubtaskDetailPanel";
import NumeroOrdineCommessa from "./NumeroOrdineCommessa";
import ProjectCalendar from "./ProjectCalendar";
import ProjectDashboard from "./ProjectDashboard";
import ProjectKanban from "./ProjectKanban";
import ProjectGantt from "./ProjectGantt";
import ProjectTimeline from "./ProjectTimeline";
import CustomFieldsManagerPanel from "./CustomFieldsManagerPanel";
import { dirittiPieni, puoCondividereCommessa, ruoloInCommessa } from "../utils/condivisione";
import { avvisaCambioStato } from "../utils/avvisiAttivita";
import { campiCompletamento, avvisoCompletamentoDiAltri } from "../utils/completamentoAttivita";
import { useSottoattivitaDi, spuntaSottoattivita } from "../utils/sottoattivitaElenco";
import BadgeSottoattivita from "./BadgeSottoattivita";
import ShareProjectModal from "./ShareProjectModal";
import ZonaModulo from "./ZonaModulo";
import PraticheTab from "./PraticheTab";
import SicurezzaCantiereTab, { AvvisoSicurezza } from "./SicurezzaCantiere";
import { EVENTO_SCHEDA_COMMESSA } from "../utils/guidaOnline";
import { ricordaScheda } from "../utils/statoNavigazione";
// Scheda della commessa → modulo del listino (le schede non elencate sono Free)
const SCHEDA_MODULO = {
  "cabina-regia": "direzione", "report": "report",
  "richieste-commerciali": "offerte", "verbali": "offerte",
  "economico": "economico", "sal": "economico", "extra": "economico", "cronoprogramma": "economico", "ordine-cavi": "economico",
  "manutenzione": "manutenzione", "registro-interventi": "manutenzione",
  "materiali": "acquisti", "richiedi-nf": "acquisti",
  "pratiche": "pratiche",
  "sicurezza": "sicurezza",
};

function NewSectionModal({ projectId, onClose }) {
  const { addToast } = useToast();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRef = useRef();
  useEffect(() => { setTimeout(() => inputRef.current?.focus(), 100); }, []);

  const submit = async e => {
    e.preventDefault();
    if (!name.trim()) return;
    if (!projectId) {
      addToast("Errore: ID progetto mancante. Riapri il progetto e riprova.", "error");
      return;
    }
    setLoading(true);
    try {
      const sectionData = {
        name: name.trim(),
        projectId: String(projectId),
        createdAt: serverTimestamp()
      };
      const ref = await addDoc(collection(db, "sections"), sectionData);
      addToast("Sezione creata!", "success");
      onClose();
    } catch(err) {
      console.error("Errore sezione:", err);
      addToast(messaggioErrore(err, "creare la sezione"), "error");
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 380 }}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
          <h3 style={{ fontSize:16, fontWeight:700 }}>Nuova sezione</h3>
          <button className="btn-icon" onClick={onClose}><X size={16}/></button>
        </div>
        <form onSubmit={submit}>
          <input ref={inputRef} className="input" value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Es. Fase 1, Pianificazione, Esecuzione..."
            style={{ marginBottom:12 }} required/>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
            <button type="button" className="btn btn-secondary" onClick={onClose}>Annulla</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? "Creo..." : "Crea sezione"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

// Riga di una sottoattività aperta sotto l'attività madre (stesse colonne dell'elenco)
function SubtaskRow({ st, task, onSelectSubtask, commessaChiusa=false, ruoloAttivita="pieno", projectId=null }) {
  const { currentUser } = useAuth();
  const { addToast } = useToast();
  const fatta = st.status === "completata", annullata = st.status === "annullata";
  const scaduta = !fatta && !annullata && isTaskOverdue(st);
  const spunta = async e => {
    e.stopPropagation();
    if (commessaChiusa) return;
    try { await spuntaSottoattivita(st, { ruoloAttivita, utente: currentUser, projectId, addToast }); }
    catch (err) { addToast(messaggioErrore(err, "aggiornare la sottoattività"), "error"); }
  };
  return (
    <div className="task-row" style={{ background:"#fcfcfd", minHeight:34 }} onClick={() => onSelectSubtask && onSelectSubtask(task, st)}>
      <div style={{ width:25, flexShrink:0 }}/>
      <div className="task-row-check" onClick={e => e.stopPropagation()}>
        <div className={`check-circle ${fatta ? "checked" : ""}`} style={{ width:15, height:15, cursor: commessaChiusa ? "default" : "pointer" }} onClick={spunta}>
          {fatta && <svg width={9} height={9} viewBox="0 0 10 10"><polyline points="1,5 4,8 9,2" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round"/></svg>}
        </div>
      </div>
      <div className="task-row-name" style={{ paddingLeft:18, paddingTop:6, paddingBottom:6 }}>
        <span style={{ display:"block", fontSize:13, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap",
          textDecoration: fatta || annullata ? "line-through" : "none", color: fatta || annullata ? "#9ca3af" : scaduta ? "#dc2626" : "#374151" }}>
          {st.title}
        </span>
      </div>
      <div className="task-row-cell" style={{ fontSize:11.5, color: fatta ? "#9ca3af" : annullata ? "#dc2626" : scaduta ? "#dc2626" : "#6b7280" }}>
        {fatta ? "✓ Completata" : annullata ? "Annullata" : scaduta ? "Scaduta" : "Sottoattività"}
      </div>
      <div className="task-row-cell" style={{ fontSize:12, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
        {st.assignedName || <span style={{ color:"#d1d5db" }}>—</span>}
      </div>
      <div className="task-row-cell date-col" style={{ color:"#d1d5db", fontSize:12 }}>—</div>
      <div className="task-row-cell date-col" style={{ color: scaduta ? "#dc2626" : st.dueDate ? "#374151" : "#d1d5db", fontSize:12 }}>
        {st.dueDate ? st.dueDate.split("-").reverse().join("/") : "—"}
      </div>
      <div className="task-row-cell"/>
      <div className="task-row-cell">
        {st.priority && <span className={`badge badge-${st.priority}`} style={{ fontSize:10.5 }}>{st.priority}</span>}
      </div>
    </div>
  );
}

function TaskRow({ task, onSelect, selected, sectionId, commessaChiusa=false, dirittiCtx=null, sottoattivita=[], aperto=false, onApri=null }) {
  const today = toLocalDateStr(new Date());
  const { currentUser } = useAuth();
  const { addToast } = useToast();
  // Stato e ordine li cambia solo chi ha pieni diritti sull'attività (utils/condivisione.js)
  const pieno = !dirittiCtx || dirittiPieni(task, dirittiCtx);
  const fermo = commessaChiusa || !pieno;
  const isOverdue = isTaskOverdue(task);
  const [isDragOver, setIsDragOver] = useState(false);

  const toggle = async e => {
    e.stopPropagation();
    if (fermo) return;
    const completata = task.status !== "completata";
    avvisaCambioStato(task, completata ? "completata" : "aperta", currentUser);
    const dopo = completata ? "completata" : "aperta";
    await updateDoc(doc(db, "tasks", task.id), { status: dopo, ...campiCompletamento(dopo, currentUser), updatedAt: serverTimestamp() });
    const viola = completata ? avvisoCompletamentoDiAltri(task, currentUser?.uid) : null;
    if (viola) addToast(viola, "viola", 8000);
  };

  return (
    <div className="task-row"
      draggable={!fermo}
      onDragStart={e => {
        if (fermo) return;
        _dragTaskId = task.id;
        _dragTaskSectionId = sectionId;
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.setData("text/plain", task.id);
        e.currentTarget.style.opacity = "0.5";
      }}
      onDragEnd={e => {
        _dragTaskId = null;
        _dragTaskSectionId = null;
        setIsDragOver(false);
        e.currentTarget.style.opacity = "1";
      }}
      onDragOver={e => { if (!commessaChiusa && _dragTaskId && _dragTaskId !== task.id) { e.preventDefault(); setIsDragOver(true); }}}
      onDragLeave={e => { if(!e.currentTarget.contains(e.relatedTarget)) setIsDragOver(false); }}
      onDrop={async e => {
        e.preventDefault();
        setIsDragOver(false);
        if (commessaChiusa || !_dragTaskId || _dragTaskId === task.id) return;
        const baseOrder = task.order !== undefined
          ? task.order
          : (task.createdAt?.toMillis?.() || Date.now());
        const nuovoOrder = baseOrder - 1;
        await updateDoc(doc(db, "tasks", _dragTaskId), {
          sectionId, order: nuovoOrder, updatedAt: serverTimestamp()
        });
        _dragTaskId = null;
        _dragTaskSectionId = null;
      }}
      style={{ background: selected ? "#faf5ff" : isDragOver ? "#f0fdf4" : undefined,
        borderTop: isDragOver ? "2px solid #7c3aed" : undefined, cursor: fermo ? "pointer" : "grab" }}
      onClick={e => { if(!e.defaultPrevented) onSelect(task); }}>
      {/* Indicatore drag visivo */}
      <div style={{ color:"#d1d5db", padding:"0 6px 0 4px", fontSize:15, flexShrink:0, userSelect:"none" }}
        className="task-drag-handle">⠿</div>
      <div className="task-row-check" onClick={e => e.stopPropagation()}>
        <div className={`check-circle ${task.status === "completata" ? "checked" : ""}`}
          style={{ width:18, height:18, cursor: fermo ? "default" : "pointer" }} onClick={toggle}
          title={!pieno && !commessaChiusa ? "Lo stato lo cambia chi segue l'attività" : undefined}>
          {task.status === "completata" && (
            <svg width={11} height={11} viewBox="0 0 10 10">
              <polyline points="1,5 4,8 9,2" stroke="#fff" strokeWidth="2" fill="none" strokeLinecap="round"/>
            </svg>
          )}
        </div>
      </div>
      <div className="task-row-name">
        <div style={{ display:"flex", alignItems:"center", gap:6, minWidth:0, overflow:"hidden" }}>
          <div className={`priority-dot ${task.priority || "media"}`}/>
          <span style={{
            fontSize:13.5,
            overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", minWidth:0,
            textDecoration: task.status === "completata" || task.status === "annullata" ? "line-through" : "none",
            color: task.status === "completata" || task.status === "annullata" ? "#9ca3af"
                 : task.status === "sospesa" ? "#d97706"
                 : isOverdue ? "#dc2626" : "#111827"
          }}>
            {task.title}
          </span>
          <BadgeSottoattivita lista={sottoattivita} aperto={aperto} onClick={onApri}/>
        </div>
      </div>
      <div className="task-row-cell">
        {task.status === "completata" ? (
          <span style={{ fontSize:12, fontWeight:600, color:"#9ca3af" }}>✓ Completata</span>
        ) : task.status === "annullata" ? (
          <span style={{ fontSize:12, fontWeight:600, color:"#dc2626" }}>🚫 Annullata</span>
        ) : task.status === "sospesa" ? (
          <span style={{ fontSize:12, fontWeight:600, color:"#d97706" }}>⏸ Sospesa</span>
        ) : isOverdue ? (
          <span style={{ fontSize:12, fontWeight:600, color:"#dc2626" }}>Scaduta</span>
        ) : (
          <span style={{ fontSize:12, fontWeight:600, color:"#059669" }}>Attiva</span>
        )}
      </div>
      <div className="task-row-cell">
        {task.assignedName ? (
          <div style={{ display:"flex", alignItems:"center", gap:6 }}>
            <div className="avatar" style={{ width:22, height:22, fontSize:11 }}>
              {task.assignedName[0]?.toUpperCase()}
            </div>
            <span style={{ fontSize:12, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>
              {task.assignedName}
            </span>
          </div>
        ) : <span style={{ color:"#d1d5db", fontSize:13 }}>—</span>}
      </div>
      <div className="task-row-cell date-col" style={{
        color: task.startDate ? "#374151" : "#d1d5db", fontSize:12.5
      }}>
        {task.startDate ? task.startDate.split("-").reverse().join("/") : "—"}
      </div>
      <div className="task-row-cell date-col" style={{
        color: isOverdue ? "#dc2626" : task.dueDate ? "#374151" : "#d1d5db", fontSize:12.5
      }}>
        {task.dueDate ? `${task.dueDate.split("-").reverse().join("/")}${task.dueTime ? " " + task.dueTime : ""}` : "—"}
      </div>
      <div className="task-row-cell" style={{ fontSize:12.5, color: task.createdAt ? "#374151" : "#d1d5db" }}>
        {(() => {
          if (!task.createdAt?.toDate) return "—";
          const apertura = task.createdAt.toDate();
          // Se l'attività è chiusa (completata/annullata), il conteggio si ferma al giorno
          // in cui è successo — stessa logica già usata per "Giorni" nel Registro Commesse.
          const fine = (task.status==="completata"||task.status==="annullata") && task.completedAt?.toDate
            ? task.completedAt.toDate() : new Date();
          const giorni = Math.max(0, Math.floor((fine - apertura) / 86400000));
          return `${giorni}g`;
        })()}
      </div>
      <div className="task-row-cell">
        {task.priority && <span className={`badge badge-${task.priority}`}>{task.priority}</span>}
      </div>
    </div>
  );
}

function InlineAddTask({ sectionId, projectId, organizationId, onDone, onSelectTask, users }) {
  const { currentUser } = useAuth();
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const ref = useRef();
  const savedRef = useRef(false); // evita doppio salvataggio se Invio e blur scattano insieme
  useEffect(() => { ref.current?.focus(); }, []);

  const save = async (chiudiDopo) => {
    if (savedRef.current) return;
    if (!title.trim()) { if (chiudiDopo) onDone(); return; }
    savedRef.current = true;
    setLoading(true);
    const nuovoRef = await addDoc(collection(db, "tasks"), {
      title: title.trim(),
      sectionId, projectId, organizationId,
      status: "aperta", priority: "media",
      assignedTo: "", assignedName: "", dueDate: "",
      description: "", tags: [],
      reminderEnabled: false, reminderDays: 1,
      recurrence: "nessuna", customFields: {},
      createdBy: currentUser.uid,
      createdByName: currentUser.displayName,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    // Stile Asana: la nuova attività si apre subito nel pannello a destra,
    // dove si impostano con calma scadenza, assegnatario, priorità, ecc.
    if (onSelectTask) {
      onSelectTask({ id: nuovoRef.id, title: title.trim(), sectionId, projectId,
        organizationId, status: "aperta", priority: "media", assignedTo: "", assignedName: "", dueDate: "" });
    }
    if (chiudiDopo) {
      setTitle(""); savedRef.current = false;
      onDone();
    } else {
      // Invio: svuota e resta pronta per la prossima aggiunta rapida
      setTitle(""); setLoading(false); savedRef.current = false;
      ref.current?.focus();
    }
  };

  return (
    <div style={{ borderBottom:"1px solid #f3f4f6", background:"#faf5ff" }}>
      <div style={{ display:"flex", alignItems:"center", padding:"8px 8px 8px 44px" }}>
        <div className="check-circle" style={{ width:18, height:18, marginRight:8, flexShrink:0 }}/>
        <input ref={ref} value={title}
          onChange={e => setTitle(e.target.value)}
          onKeyDown={e => { if (e.key === "Enter") save(false); if (e.key === "Escape") onDone(); }}
          onBlur={() => save(true)}
          disabled={loading}
          className="inline-input" placeholder="Nome attività..." style={{ flex:1 }}/>
      </div>
    </div>
  );
}

function SectionBlock({ section, projectId, organizationId, selectedTaskId, onSelectTask, onSelectSubtask=null, taskSearch, soloMieAttività, currentUserUid, isAdmin, onDragSezStart, onDragSezEnd, commessaChiusa=false, dirittiCtx=null, puoRiordinare=true }) {
  const { userProfile, isOrgAdmin, canSeeEconomic, isPlatformOwner } = useAuth();
  const { addToast } = useToast();
  const [tasks, setTasks] = useState([]);
  const [users, setUsers] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const [addingTask, setAddingTask] = useState(false);
  const [editingName, setEditingName] = useState(false);
  const [newName, setNewName] = useState(section.name);
  const [showMenu, setShowMenu] = useState(false);
  const [showFieldsManager, setShowFieldsManager] = useState(false);

  useEffect(() => {
    const q = query(collection(db, "tasks"), where("sectionId", "==", section.id), where("organizationId","==",organizationId));
    return onSnapshot(q, snap => {
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      list.sort((a, b) => {
        // Prima per order esplicito, poi per createdAt
        const aOrd = a.order !== undefined ? a.order : (a.createdAt?.toMillis?.() || 0);
        const bOrd = b.order !== undefined ? b.order : (b.createdAt?.toMillis?.() || 0);
        return aOrd - bOrd;
      });
      setTasks(list);
    });
  }, [section.id]);

  // Filtra le attività in base alla ricerca e al ruolo
  const tasksFiltrati = tasks
    .filter(t => !soloMieAttività || t.assignedTo===currentUserUid)
    .filter(t => !taskSearch || (
      t.title?.toLowerCase().includes(taskSearch) ||
      t.assignedName?.toLowerCase().includes(taskSearch) ||
      t.tags?.some(tag => tag.toLowerCase().includes(taskSearch))
    ));

  useEffect(() => {
    if (!organizationId) return;
    getDocs(query(collection(db, "users"), where("organizationId", "==", organizationId), where("enabled", "==", true)))
      .then(snap => setUsers(snap.docs.map(d => d.data())))
      .catch(err => {
        console.error("Errore caricamento utenti (SectionBlock):", err);
        addToast("Impossibile caricare l'elenco utenti: "+(err?.message||"errore sconosciuto"),"error");
      });
  }, [organizationId]);

  const renameSection = async () => {
    if (commessaChiusa) { setEditingName(false); return; }
    if (newName.trim() && newName !== section.name) {
      await updateDoc(doc(db, "sections", section.id), { name: newName.trim() });
    }
    setEditingName(false);
  };

  const deleteSection = async () => {
    if (commessaChiusa) return;
    if (!await confirm(`Eliminare la sezione "${section.name}" e tutte le sue attività?`, { type:"danger" })) return;
    const snap = await getDocs(query(collection(db, "tasks"), where("sectionId", "==", section.id), where("organizationId","==",organizationId)));
    for (const t of snap.docs) await deleteDoc(doc(db, "tasks", t.id));
    await deleteDoc(doc(db, "sections", section.id));
    addToast("Sezione eliminata", "info");
  };

  const done = tasks.filter(t => t.status === "completata").length;

  // Sottoattività delle attività della sezione (per l'indicatore e per aprirle sotto la riga)
  const sottoPerAttivita = useSottoattivitaDi(tasks.map(t => t.id), organizationId);
  const [aperte, setAperte] = useState({});
  const apri = id => setAperte(a => ({ ...a, [id]: !a[id] }));

  return (
    <div>
      <div className="section-header">
        {puoRiordinare && <span draggable
          onDragStart={e=>{ e.stopPropagation(); if(onDragSezStart) onDragSezStart(); }}
          onDragEnd={e=>{ e.stopPropagation(); if(onDragSezEnd) onDragSezEnd(); }}
          onClick={e=>e.stopPropagation()}
          title="Trascina per riordinare"
          style={{ cursor:"grab", color:"#9ca3af", fontSize:14, lineHeight:1, padding:"0 6px 0 2px", flexShrink:0 }}>⠿</span>}
        <button className="section-collapse-btn" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? <ChevronRight size={14}/> : <ChevronDown size={14}/>}
        </button>
        {editingName ? (
          <input value={newName} onChange={e => setNewName(e.target.value)}
            onBlur={renameSection}
            onKeyDown={e => { if (e.key === "Enter") renameSection(); if (e.key === "Escape") setEditingName(false); }}
            style={{ border:"1px solid #7c3aed", borderRadius:4, padding:"2px 8px", fontSize:13, fontWeight:700, fontFamily:"'Inter',sans-serif", outline:"none" }}
            autoFocus/>
        ) : (
          <span style={{ cursor: (isOrgAdmin&&!commessaChiusa) ? "pointer" : "default" }}
            onDoubleClick={() => isOrgAdmin && !commessaChiusa && setEditingName(true)}>
            {section.name}
          </span>
        )}
        <span style={{ fontSize:12, color:"#9ca3af", fontWeight:400 }}>
          {tasks.length} attività{tasks.length > 0 ? ` · ${done} completate` : ""}
        </span>
        {tasks.length > 0 && (
          <div style={{ width:60, height:4, background:"#e5e7eb", borderRadius:10, overflow:"hidden" }}>
            <div style={{ width:`${Math.round(done/tasks.length*100)}%`, height:"100%", background:"#059669", borderRadius:10 }}/>
          </div>
        )}
        <div style={{ marginLeft:"auto", width:140*6, display:"flex", alignItems:"center", justifyContent:"flex-end", flexShrink:0, position:"relative" }}>
          <button className="btn-icon" onClick={() => setShowMenu(!showMenu)}>
            <MoreHorizontal size={15}/>
          </button>
          {showMenu && (
            <div style={{ position:"absolute", right:0, top:"100%", background:"#fff", border:"1px solid #e5e7eb", borderRadius:8, boxShadow:"0 8px 24px rgba(0,0,0,0.12)", zIndex:100, minWidth:190, padding:4 }}
              onClick={() => setShowMenu(false)}>
              {isOrgAdmin && !commessaChiusa && <>
                <button onClick={() => setEditingName(true)}
                  style={{ width:"100%", padding:"8px 12px", border:"none", background:"transparent", cursor:"pointer", textAlign:"left", fontSize:13, display:"flex", alignItems:"center", gap:8, fontFamily:"'Inter',sans-serif", borderRadius:4 }}>
                  <Edit2 size={13}/> Rinomina
                </button>
                <button onClick={() => setShowFieldsManager(true)}
                  style={{ width:"100%", padding:"8px 12px", border:"none", background:"transparent", cursor:"pointer", textAlign:"left", fontSize:13, display:"flex", alignItems:"center", gap:8, fontFamily:"'Inter',sans-serif", borderRadius:4 }}>
                  <Settings2 size={13}/> Campi personalizzati
                </button>
                <hr style={{ border:"none", borderTop:"1px solid #f3f4f6", margin:"4px 0" }}/>
                <button onClick={deleteSection}
                  style={{ width:"100%", padding:"8px 12px", border:"none", background:"transparent", cursor:"pointer", textAlign:"left", fontSize:13, display:"flex", alignItems:"center", gap:8, fontFamily:"'Inter',sans-serif", color:"#dc2626", borderRadius:4 }}>
                  <Trash2 size={13}/> Elimina sezione
                </button>
              </>}
              {(!isOrgAdmin || commessaChiusa) && (
                <div style={{ padding:"8px 12px", fontSize:13, color:"#9ca3af" }}>{commessaChiusa?"🔒 Commessa chiusa":"Nessuna azione disponibile"}</div>
              )}
            </div>
          )}
        </div>
      </div>

      {!collapsed && (
        <>
          {tasksFiltrati.map(task => (
            <React.Fragment key={task.id}>
              <TaskRow task={task} onSelect={onSelectTask} selected={selectedTaskId === task.id} sectionId={section.id} commessaChiusa={commessaChiusa} dirittiCtx={dirittiCtx}
                sottoattivita={sottoPerAttivita[task.id] || []} aperto={!!aperte[task.id]} onApri={() => apri(task.id)}/>
              {aperte[task.id] && (sottoPerAttivita[task.id] || []).map(st => (
                <SubtaskRow key={st.id} st={st} task={task} onSelectSubtask={onSelectSubtask} commessaChiusa={commessaChiusa} projectId={projectId}
                  ruoloAttivita={!dirittiCtx || dirittiPieni(task, dirittiCtx) ? "pieno" : "collabora"}/>
              ))}
            </React.Fragment>
          ))}
          {addingTask && !commessaChiusa && (
            <InlineAddTask sectionId={section.id} projectId={projectId} organizationId={organizationId} users={users} onDone={() => setAddingTask(false)} onSelectTask={onSelectTask}/>
          )}
          {!addingTask && !commessaChiusa && (
            <div className="add-task-row" onClick={() => setAddingTask(true)}>
              <Plus size={14}/> Aggiungi attività
            </div>
          )}
        </>
      )}

      {showFieldsManager && (
        <CustomFieldsManagerPanel sectionId={section.id} sectionName={section.name} projectId={projectId} onClose={() => setShowFieldsManager(false)}/>
      )}
    </div>
  );
}

function ListView({ projectId, organizationId, selectedTask, onSelectTask, onSelectSubtask=null, taskSearch, soloMieAttività, currentUserUid, commessaChiusa=false, dirittiCtx=null, puoRiordinare=true }) {
  const { isOrgAdmin, isPlatformOwner } = useAuth();
  const [sections, setSections] = useState([]);
  const dragSezIdx = useRef(null);
  const dragOverSezIdx = useRef(null);
  // dragTask/dragTaskOver ora sono variabili globali al modulo: _dragTaskId, _dragTaskSectionId
  const [allTasks, setAllTasks] = useState([]);
  const [showNewSection, setShowNewSection] = useState(false);

  useEffect(() => {
    if (!projectId) return;
    const q = query(collection(db, "sections"), where("projectId", "==", projectId));
    return onSnapshot(q, snap => {
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      list.sort((a, b) => {
        // Prima per campo order, poi per createdAt come fallback
        if (a.order !== undefined && b.order !== undefined) return a.order - b.order;
        if (a.order !== undefined) return -1;
        if (b.order !== undefined) return 1;
        return (a.createdAt?.toMillis?.() || 0) - (b.createdAt?.toMillis?.() || 0);
      });
      setSections(list);
    });
  }, [projectId]);

  useEffect(() => {
    if (!projectId) return;
    const q = query(collection(db, "tasks"), where("projectId", "==", projectId), where("organizationId","==",organizationId));
    return onSnapshot(q, snap => setAllTasks(snap.docs.map(d => ({ id: d.id, ...d.data() }))));
  }, [projectId]);

  // Se c'è una ricerca attiva, filtra le sezioni che hanno almeno un'attività corrispondente
  const searchLower = taskSearch?.toLowerCase() || "";
  const salvaOrdineSezioni = async (nuovaLista) => {
    // Salva campo order su ogni sezione
    await Promise.all(nuovaLista.map((s, i) =>
      updateDoc(doc(db, "sections", s.id), { order: i })
    ));
  };

  const sectionsFiltrate = searchLower
    ? sections.filter(s => {
        const nomeSection = s.name?.toLowerCase().includes(searchLower);
        const hasTasks = allTasks.some(t => t.sectionId === s.id &&
          (t.title?.toLowerCase().includes(searchLower) ||
           t.assignedName?.toLowerCase().includes(searchLower) ||
           t.tags?.some(tag => tag.toLowerCase().includes(searchLower))));
        return nomeSection || hasTasks;
      })
    : sections;

  return (
    <div style={{ flex:1, overflowY:"auto", height:"100%" }}>
      <div className="list-header">
        <div style={{ width:25, flexShrink:0 }}/>
        <div style={{ width:44, flexShrink:0 }}/>
        <div className="list-header-name" style={{ paddingLeft:0 }}>Nome attività</div>
        <div className="list-header-cell">Stato</div>
        <div className="list-header-cell">Assegnatario</div>
        <div className="list-header-cell date-col">Data di inizio</div>
        <div className="list-header-cell date-col">Data di scadenza</div>
        <div className="list-header-cell">Giorni aperta</div>
        <div className="list-header-cell">Priorità</div>
      </div>

      {sections.length === 0 ? (
        <div className="empty-state">
          <div style={{ fontSize:40, marginBottom:12 }}>📋</div>
          <h3>Nessuna sezione ancora</h3>
          <p>Crea la prima sezione per organizzare le attività del progetto</p>
          {isOrgAdmin && !commessaChiusa && (
            <button className="btn btn-primary" onClick={() => setShowNewSection(true)}>
              <Plus size={14}/> Crea prima sezione
            </button>
          )}
        </div>
      ) : sectionsFiltrate.length === 0 && searchLower ? (
        <div style={{padding:48,textAlign:"center",color:"#9ca3af"}}>
          <div style={{fontSize:32,marginBottom:8}}>🔍</div>
          <div style={{fontSize:14,fontWeight:600}}>Nessun risultato per "{taskSearch}"</div>
          <div style={{fontSize:12,marginTop:4}}>Prova con un altro termine</div>
        </div>
      ) : (
        sectionsFiltrate.map((section, idx) => (
          <div key={section.id}
            onDragOver={e => {
              e.preventDefault();
              if (!_dragTaskId) {
                dragOverSezIdx.current = idx;
              }
            }}
            onDrop={e => {
              if (commessaChiusa) return;
              // Drop task su sezione diversa
              if (_dragTaskId && _dragTaskSectionId !== section.id) {
                updateDoc(doc(db, "tasks", _dragTaskId), {
                  sectionId: section.id, order: Date.now() + 99999, updatedAt: serverTimestamp()
                });
                _dragTaskId = null;
                _dragTaskSectionId = null;
                return;
              }
              // Drop sezione
              if (!_dragTaskId && dragSezIdx.current !== null && dragSezIdx.current !== idx) {
                const nuova = [...sections];
                const [rimossa] = nuova.splice(dragSezIdx.current, 1);
                nuova.splice(idx, 0, rimossa);
                setSections(nuova);
                salvaOrdineSezioni(nuova);
                dragSezIdx.current = null;
              }
            }}>
            <SectionBlock section={section}
              projectId={projectId} organizationId={organizationId}
              selectedTaskId={selectedTask?.id} onSelectTask={onSelectTask} onSelectSubtask={onSelectSubtask}
              taskSearch={searchLower} soloMieAttività={soloMieAttività} currentUserUid={currentUserUid}
              isAdmin={isOrgAdmin||isPlatformOwner} commessaChiusa={commessaChiusa}
              dirittiCtx={dirittiCtx} puoRiordinare={puoRiordinare && !commessaChiusa}
              onDragSezStart={()=>{ if(!commessaChiusa && puoRiordinare) dragSezIdx.current = idx; }}
              onDragSezEnd={()=>{ dragSezIdx.current = null; }}/>
          </div>
        ))
      )}

      {sections.length > 0 && isOrgAdmin && !commessaChiusa && (
        <div style={{ padding:"12px 20px" }}>
          <button className="btn btn-ghost" onClick={() => setShowNewSection(true)}
            style={{ fontSize:13, color:"#6b7280" }}>
            <Plus size={14}/> Aggiungi sezione
          </button>
        </div>
      )}

      {showNewSection && !commessaChiusa && (
        <NewSectionModal projectId={projectId} onClose={() => setShowNewSection(false)}/>
      )}
    </div>
  );
}

const EXTRA_TABS = [
  { id:"board", label:"Bacheca" },
  { id:"gantt", label:"Gantt" },
  { id:"timeline", label:"Cronologia" },
];


// Rinomina progetto inline
function EditableProjectName({ projectId, name, onRenamed }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(name);
  const inputRef = useRef();

  useEffect(() => { setVal(name); }, [name]);
  useEffect(() => { if (editing) inputRef.current?.focus(); }, [editing]);

  const save = async () => {
    if (val.trim() && val !== name) {
      await updateDoc(doc(db, "projects", projectId), { name: val.trim() });
      if (onRenamed) onRenamed(val.trim());
    }
    setEditing(false);
  };

  if (editing) return (
    <input ref={inputRef} value={val} onChange={e=>setVal(e.target.value)}
      onBlur={save}
      onKeyDown={e=>{ if(e.key==="Enter") save(); if(e.key==="Escape") setEditing(false); }}
      style={{ fontSize:16, fontWeight:600, border:"none", borderBottom:"2px solid #7c3aed", outline:"none", fontFamily:"'Inter',sans-serif", background:"transparent", color:"#111827", minWidth:120, maxWidth:400 }}/>
  );
  return (
    <span className="topbar-title" style={{ cursor:"pointer" }} title="Clicca per rinominare"
      onClick={() => setEditing(true)}>{name}</span>
  );
}

export default function ProjectView({ project, initialTab, initialTaskId, onNavigate }) {
  const { userProfile, isOrgAdmin, canSeeEconomic, isPlatformOwner, currentUser } = useAuth();
  const canSee = useCanSee();
  const { addToast } = useToast();
  const { effectiveOrgId: organizationId } = useOrg();
  const { hasFeature } = useFeatures();
  const canToggleEconomico = isPlatformOwner || isOrgAdmin;
  const controlloEconomicoGlobale = hasFeature("controlloEconomico");
  const [economicoAbilitato, setEconomicoAbilitato] = useState(false);
  const [cronoprogrammaAbilitato, setCronoprogrammaAbilitato] = useState(false);
  const [manutenzioneAbilitata, setManutenzioneAbilitata] = useState(false);
  const [giornaleAbilitato, setGiornaleAbilitato] = useState(false);
  const [ordineCaviAbilitato, setOrdineCaviAbilitato] = useState(false);
  const [registroInterventiAbilitato, setRegistroInterventiAbilitato] = useState(false);
  const [richiesteCommAbilitato, setRichiesteCommAbilitato] = useState(false);
  const [salAbilitato, setSalAbilitato] = useState(false);
  const [extraAbilitato, setExtraAbilitato] = useState(false);
  const [showRelazioneFinale, setShowRelazioneFinale] = useState(false);
  const [ddtAbilitato, setDdtAbilitato] = useState(false);
  const [ddtIngressoAbilitato, setDdtIngressoAbilitato] = useState(false);
  const [comunicazioniAbilitato, setComunicazioniAbilitato] = useState(false);
  const [reportAbilitato, setReportAbilitato] = useState(false);
  const [projectData, setProjectData] = useState(project);
  // Anagrafica del cliente: serve a sapere se ha una sola sede (che vale come sede dei lavori)
  const [clienteDoc, setClienteDoc] = useState(null);
  const clienteIdCommessa = projectData?.clienteId || "";
  useEffect(() => {
    if (!clienteIdCommessa) { setClienteDoc(null); return undefined; }
    return onSnapshot(doc(db, "clienti", clienteIdCommessa), s => setClienteDoc(s.exists() ? s.data() : null), () => setClienteDoc(null));
  }, [clienteIdCommessa]);
  const sedeEffettiva = React.useMemo(() => sedeLavori(projectData, clienteDoc), [projectData, clienteDoc]);
  const [nomeCommessaOriginale, setNomeCommessaOriginale] = useState("");
  // "Manutenzione di" — collegamento già esistente nella creazione commessa (facoltativo,
  // per chi ha davvero un lavoro originale a cui agganciare il contratto) ma mai mostrato
  // da nessuna parte finora: veniva salvato e subito dimenticato. Qui si chiude il cerchio.
  useEffect(()=>{
    if (!projectData?.manutenzioneDiProjectId) { setNomeCommessaOriginale(""); return; }
    getDoc(doc(db,"projects",projectData.manutenzioneDiProjectId)).then(s=>{
      setNomeCommessaOriginale(s.exists() ? (s.data().name||"") : "");
    });
  },[projectData?.manutenzioneDiProjectId]);
  // Commessa chiusa = sola consultazione ovunque nella commessa (Attività, Economico,
  // Cronoprogramma, Giornale di Cantiere). Riapri la commessa per tornare a modificare.
  const commessaChiusa = projectData?.statoCommessa === "chiusa";
  // Cabina di Regia: Titolare/Gestione la vedono sempre (canSee gestisce anche il bypass
  // admin/titolare); chiunque altro solo se è il responsabile di QUESTA commessa specifica —
  // mai su commesse altrui, indipendentemente dal proprio ruolo generale.
  const puoVedereCabinaRegia = canSee("cabina-regia") || projectData?.responsabileUid === currentUser?.uid;
  const [selectedTask, setSelectedTask] = useState(null);
  // Elemento da aprire in una scheda (es. una variante o una comunicazione cliccata nella Cabina di Regia)
  const [apriElemento, setApriElemento] = useState(null);
  // Aperta dal link di un'email: si apre subito anche l'attività indicata
  useEffect(() => {
    if (!initialTaskId) return;
    getDoc(doc(db, "tasks", initialTaskId)).then(snap => { if (snap.exists()) setSelectedTask({ id: snap.id, ...snap.data() }); }).catch(() => {});
  }, [initialTaskId]);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  // Se si apre un'altra attività, il pannello della sottoattività di quella precedente si chiude
  const idAttivitaAperta = selectedTask?.id || null;
  useEffect(() => {
    setSelectedSubtask(st => (st && idAttivitaAperta && st.parentTaskId !== idAttivitaAperta ? null : st));
  }, [idAttivitaAperta]);
  const [activeTab, setActiveTab] = useState(initialTab || "list");
  // Se il telefono ricarica la pagina, si riapre questa stessa scheda (utils/statoNavigazione.js)
  const uidUtente = currentUser?.uid;
  useEffect(() => { ricordaScheda(uidUtente, project?.id, activeTab); }, [uidUtente, project?.id, activeTab]);
  // La barra laterale apre la guida della scheda attiva (sul sito, in una nuova scheda del browser)
  useEffect(() => {
    window.dispatchEvent(new CustomEvent(EVENTO_SCHEDA_COMMESSA, { detail: activeTab }));
  }, [activeTab]);
  const [taskSearch, setTaskSearch] = useState("");
  const [showNewSection, setShowNewSection] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [showRichiestaFatturazione, setShowRichiestaFatturazione] = useState(false);
  const [activeTabs, setActiveTabs] = useState(["list","calendar","dashboard"]);

  // projectId deve essere definito prima degli useEffect che lo usano
  const projectId = project?.id || null;
  // Ruolo dell'utente corrente in questo progetto
  // Ruolo nella commessa: membro (responsabile/operativo) oppure collega con cui è condivisa.
  // Chi l'ha ricevuta in condivisione vede tutte le attività e collabora (utils/condivisione.js).
  const mioRuolo = ruoloInCommessa(projectData, currentUser?.uid);
  const soloMieAttività = mioRuolo==="operativo" && !isOrgAdmin && !isPlatformOwner;
  const adminCommessa = !!(isOrgAdmin || isPlatformOwner || ["admin","titolare"].includes(userProfile?.role));
  const dirittiCtx = { uid: currentUser?.uid, isAdmin: adminCommessa, ruoloOperativo: userProfile?.ruoloOperativo || "",
    responsabileCommessaUid: projectData?.responsabileUid || "", membriCommessa: projectData?.membri || [] };
  const puoGestireCommessa = puoCondividereCommessa(projectData, { uid: currentUser?.uid, isAdmin: adminCommessa, ruoloOperativo: userProfile?.ruoloOperativo || "" });

  // Carica viste salvate per questo progetto
  useEffect(() => {
    if (!projectId) return;
    getDoc(doc(db, "projectSettings", projectId)).then(snap => {
      if (snap.exists() && snap.data().activeTabs) {
        setActiveTabs(snap.data().activeTabs);
      }
    });
  }, [projectId]);

  // Salva viste quando cambiano
  const saveActiveTabs = async (tabs) => {
    setActiveTabs(tabs);
    if (!projectId) return;
    try {
      await setDoc(doc(db, "projectSettings", projectId), { activeTabs: tabs }, { merge: true });
    } catch(e) {}
  };
  const [showAddTab, setShowAddTab] = useState(false);
  const [posizioneAddTab, setPosizioneAddTab] = useState(null);
  const addTabRef = useRef(null);
  const addTabBtnRef = useRef(null);
  useEffect(()=>{
    if(!showAddTab) return;
    const handler = e=>{
      if(addTabBtnRef.current?.contains(e.target)) return;
      if(addTabRef.current?.contains(e.target)) return;
      setShowAddTab(false);
    };
    document.addEventListener("mousedown",handler);
    return()=>document.removeEventListener("mousedown",handler);
  },[showAddTab]);
  const [showProjectMenu, setShowProjectMenu] = useState(false);
  const [posizioneProjectMenu, setPosizioneProjectMenu] = useState(null);
  const projectMenuRef = useRef(null);
  const projectMenuBtnRef = useRef(null);
  useEffect(()=>{
    if(!showProjectMenu) return;
    const handler = e=>{
      if(projectMenuBtnRef.current?.contains(e.target)) return;
      if(projectMenuRef.current?.contains(e.target)) return;
      setShowProjectMenu(false);
    };
    document.addEventListener("mousedown",handler);
    return()=>document.removeEventListener("mousedown",handler);
  },[showProjectMenu]);
  const [showPianoModal, setShowPianoModal] = useState(false);
  const [showChiudiModal, setShowChiudiModal] = useState(false);
  const [showRiapriModal, setShowRiapriModal] = useState(false);

  const archiveProject = async () => {
    const isChiusa = projectData?.statoCommessa === "chiusa";
    const msg = isChiusa
      ? `Archiviare la commessa "${projectData?.name}"? Sarà nascosta dalla sidebar ma recuperabile.`
      : `La commessa "${projectData?.name}" non è ancora stata chiusa formalmente.\n\nVuoi archiviarla comunque? Si consiglia di chiuderla prima.`;
    if (!await confirm(msg, { type:"danger", confirmLabel: isChiusa ? "Archivia" : "Archivia comunque" })) return;
    try {
      await updateDoc(doc(db, "projects", projectId), { archived: true, archivedAt: serverTimestamp() });
    } catch (err) { addToast(messaggioErrore(err, "archiviare la commessa"), "error"); return; }
    logModifica({ orgId:organizationId, uid:currentUser?.uid||"", nomeUtente:currentUser?.displayName||"",
      sezione:"commesse", refId:projectId, refNome:project?.name||"",
      campo:"archived", campoLabel:"Archiviata", before:"No", after:"Sì", projectId, projectName:project?.name||"" });
    logEvento({ orgId:organizationId, tipo:"COMMESSA_ARCHIVIATA", projectId, projectName:projectData?.name||"", uid:currentUser?.uid, nomeUtente:currentUser?.displayName||"" });
    addToast("Commessa archiviata", "info");
    setShowProjectMenu(false);
  };


  const toggleEconomico = async () => {
    const nuovoStato = !economicoAbilitato;
    setEconomicoAbilitato(nuovoStato);
    await updateDoc(doc(db, "projects", projectId), { controlloEconomicoAbilitato: nuovoStato });
    // Se lo stiamo disabilitando e siamo sul tab economico, torna all'elenco
    if (!nuovoStato && activeTab === "economico") setActiveTab("list");
    addToast(nuovoStato ? "Controllo Economico attivato" : "Controllo Economico disattivato", "success");
  };

  // Elenco dei moduli opzionali della commessa, per il pannello unico "Personalizza
  // commessa" — stessi campi Firestore di sempre (nessuna migrazione), solo un modo diverso
  // di presentarli. La funzione generica gestisce gli 11 moduli con lo stesso pattern;
  // Economico ha nome di campo diverso e una sua funzione dedicata, riusata così com'è.
  // Chi attiva i moduli (decisione ott 2026): i moduli ECONOMICI (Controllo Economico, Report,
  // Varianti — importi, costi, margini, fatturazione) solo titolare/amministratori; tutti gli
  // altri anche il responsabile della commessa e chi ha il permesso «Attivare i moduli delle
  // commesse» (di default Gestione aziendale e Project Manager). Stessa regola nelle Regole Firestore.
  const puoModuliEconomici = !!(isOrgAdmin || isPlatformOwner);
  const puoModuliCommessa = puoModuliEconomici || (!!projectData?.responsabileUid && projectData.responsabileUid === currentUser?.uid) || canSee("moduli-commessa");
  const toggleModuloGenerico = async (m) => {
    if (m.bloccato) return;
    const nuovo = !m.value;
    m.setValue(nuovo);
    if (!nuovo && activeTab===m.tab) setActiveTab("list");
    await setDoc(doc(db,"projects",projectId), { [m.campo]: nuovo }, { merge:true });
  };
  const moduliCommessa = [
    ...(controlloEconomicoGlobale ? [{ key:"economico", economico:true, label:"Controllo Economico", emoji:"📊", colore:"#7c3aed", value:economicoAbilitato, onToggle:()=>{ if (canToggleEconomico) toggleEconomico(); } }] : []),
    { key:"cronoprogramma", label:"Cronoprogramma", emoji:"📅", colore:"#059669", value:cronoprogrammaAbilitato, setValue:setCronoprogrammaAbilitato, tab:"cronoprogramma", campo:"cronoprogrammaAbilitato" },
    { key:"manutenzione", label:"Gestione Manutenzione", emoji:"🔧", colore:"#7c3aed", value:manutenzioneAbilitata, setValue:setManutenzioneAbilitata, tab:"manutenzione", campo:"manutenzioneAbilitata" },
    { key:"registrointerventi", label:"Registro interventi", emoji:"📋", colore:"#059669", value:registroInterventiAbilitato, setValue:setRegistroInterventiAbilitato, tab:"registro-interventi", campo:"registroInterventiAbilitato" },
    { key:"ddt", label:"DDT Uscita", emoji:"📄", colore:"#0369a1", value:ddtAbilitato, setValue:setDdtAbilitato, tab:"ddt", campo:"ddtAbilitato" },
    { key:"ddtingresso", label:"DDT Ingresso", emoji:"📥", colore:"#059669", value:ddtIngressoAbilitato, setValue:setDdtIngressoAbilitato, tab:"ddt-ingresso", campo:"ddtIngressoAbilitato" },
    { key:"comunicazioni", label:"Corrispondenza", emoji:"📨", colore:"#7c3aed", value:comunicazioniAbilitato, setValue:setComunicazioniAbilitato, tab:"comunicazioni", campo:"comunicazioniAbilitato" },
    { key:"report", economico:true, label:"Report", emoji:"📊", colore:"#7c3aed", value:reportAbilitato, setValue:setReportAbilitato, tab:"report", campo:"reportAbilitato" },
    { key:"richiestecomm", label:"Richieste Commerciali", emoji:"💼", colore:"#d97706", value:richiesteCommAbilitato, setValue:setRichiesteCommAbilitato, tab:"richieste-commerciali", campo:"richiesteCommAbilitato" },
    { key:"sal", label:"Computo Metrico / SAL", emoji:"📐", colore:"#d97706", value:salAbilitato, setValue:setSalAbilitato, tab:"sal", campo:"salAbilitato" },
    { key:"extra", economico:true, label:"Varianti e lavori extra", emoji:"➕", colore:"#7c3aed", value:extraAbilitato, setValue:setExtraAbilitato, tab:"extra", campo:"extraAbilitato" },
    { key:"giornale", label:"Giornale di Cantiere", emoji:"📓", colore:"#2563eb", value:giornaleAbilitato, setValue:setGiornaleAbilitato, tab:"giornale", campo:"giornaleAbilitato" },
    { key:"ordinecavi", label:"Ordine Cavi", emoji:"🔀", colore:"#6d28d9", value:ordineCaviAbilitato, setValue:setOrdineCaviAbilitato, tab:"ordine-cavi", campo:"ordineCaviAbilitato" },
  ].map(m => ({ ...m, bloccato: m.economico ? !puoModuliEconomici : !puoModuliCommessa }))
   .map(m => m.onToggle ? m : { ...m, onToggle: () => toggleModuloGenerico(m) });

  useEffect(() => {
    if (!projectId) return;
    // Listener real-time — aggiorna projectData subito dopo ogni modifica
    const unsub = onSnapshot(doc(db, "projects", projectId), snap => {
      if (snap.exists()) {
        const data = { id: snap.id, ...snap.data() };
        setProjectData(data);
        setEconomicoAbilitato(data.controlloEconomicoAbilitato || false);
        setCronoprogrammaAbilitato(data.cronoprogrammaAbilitato || false);
        setManutenzioneAbilitata(data.manutenzioneAbilitata || false);
        setGiornaleAbilitato(data.giornaleAbilitato || false);
        setRegistroInterventiAbilitato(data.registroInterventiAbilitato || false);
        setRichiesteCommAbilitato(data.richiesteCommAbilitato || false);
        setSalAbilitato(data.salAbilitato || false);
        setExtraAbilitato(data.extraAbilitato || false);
        setDdtAbilitato(data.ddtAbilitato || false);
        setDdtIngressoAbilitato(data.ddtIngressoAbilitato || false);
        setComunicazioniAbilitato(data.comunicazioniAbilitato || false);
        setReportAbilitato(data.reportAbilitato || false);
        setOrdineCaviAbilitato(data.ordineCaviAbilitato || false);
      }
    });
    return () => unsub();
  }, [projectId]);

  const addTab = tabId => {
    if (!activeTabs.includes(tabId)) {
      const newTabs = [...activeTabs, tabId];
      saveActiveTabs(newTabs);
    }
    setActiveTab(tabId);
    setShowAddTab(false);
  };

  const TAB_LABELS = { list:"Elenco", board:"Bacheca", calendar:"Calendario", dashboard:"Dashboard", gantt:"Gantt", timeline:"Cronologia", cronoprogramma:"Cronoprogramma" };

  // Tab Controllo Economico — appare solo se abilitato per questo progetto
  const showEconomicoTab = economicoAbilitato && controlloEconomicoGlobale && canSeeEconomic;
  // Dalla Cabina di Regia: apre la scheda indicata (e, se c'è, l'elemento). Se il modulo non
  // è attivo su questa commessa lo dice, invece di aprire una scheda che non c'è.
  const vaiDallaCabina = (tab, id) => {
    const disponibile = {
      economico: showEconomicoTab, extra: extraAbilitato, sal: salAbilitato, cronoprogramma: cronoprogrammaAbilitato,
      comunicazioni: comunicazioniAbilitato, giornale: giornaleAbilitato, sicurezza: !projectData?.isParent,
    }[tab];
    if (disponibile === false) { addToast("Questo modulo non è attivo sulla commessa: si attiva da Personalizza", "viola"); return; }
    setApriElemento(id ? { tab, id } : null);
    setActiveTab(tab);
  };

  // Dati vivi della commessa (si può aprire anche solo con l'id: registri, notifiche)
  const projectForChildren = { ...project, ...(projectData || {}), id: projectId };

  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100%", overflow:"hidden" }}>
      {/* Banner piano di carico incompleto */}
      {(isOrgAdmin||isPlatformOwner) && !projectData?.isParent && (!projectData?.dataInizio||!projectData?.dataFine||!projectData?.operaiNecessari) && (
        <div style={{background:"#fef3c7",borderBottom:"1px solid #fde68a",padding:"8px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
          <span style={{fontSize:16}}>⚠️</span>
          <button onClick={()=>setShowPianoModal(true)}
            style={{background:"#d97706",border:"none",borderRadius:7,padding:"5px 12px",color:"#fff",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif",whiteSpace:"nowrap",flexShrink:0}}>
            Aggiungi dati carico →
          </button>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:12,fontWeight:700,color:"#92400e"}}>Dati incompleti per la pianificazione</div>
            <div style={{fontSize:11,color:"#78350f",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{leggiTipoEsecuzione(projectData)==="subappalto" ? "Commessa in subappalto: indica date e presidio interno (chi dei vostri segue il cantiere)." : "Commessa non inclusa nel Simulatore Disponibilità Maestranze."}</div>
          </div>
        </div>
      )}

      {/* Avviso rosso, non bloccante, della sicurezza di cantiere (components/SicurezzaCantiere.js) */}
      {projectData?.cantiere && !projectData?.isParent && projectData?.statoCommessa!=="chiusa" && activeTab!=="sicurezza" && (
        <AvvisoSicurezza projectId={projectId} projectData={projectData} onApri={()=>setActiveTab("sicurezza")}/>
      )}

      {/* Modal piano di carico */}
      {showPianoModal && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.5)",zIndex:9000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}
          onClick={e=>e.target===e.currentTarget&&setShowPianoModal(false)}>
          <div style={{background:"#fff",borderRadius:14,width:"100%",maxWidth:520,maxHeight:"92vh",overflowY:"auto",boxShadow:"0 20px 60px rgba(0,0,0,.2)"}}>
            <div style={{background:"linear-gradient(135deg,#1e1b4b,#3730a3)",padding:"16px 20px",borderRadius:"14px 14px 0 0",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <span style={{fontSize:14,fontWeight:800,color:"#fff"}}>📊 Sede, piano di carico e imprese — {projectData?.name}</span>
              <button onClick={()=>setShowPianoModal(false)} style={{background:"rgba(255,255,255,.1)",border:"none",borderRadius:6,padding:"4px 8px",cursor:"pointer",color:"#fff"}}>✕</button>
            </div>
            <div style={{padding:20}}>
              <div style={{fontSize:11,color:"#6b7280",marginBottom:16,lineHeight:1.6}}>
                Compila questi dati per includere la commessa nel Simulatore Disponibilità Maestranze e nelle analisi di capacità produttiva.
              </div>
              <PianoCaricForm projectId={projectId} projectData={projectData} onSaved={()=>{setShowPianoModal(false);addToast("Piano di carico aggiornato ✅","success");}} onClose={()=>setShowPianoModal(false)}/>
            </div>
          </div>
        </div>
      )}
      {/* Testata: altezza libera (prima era fissa e tagliava numero commessa e sede).
          Riga 1: numero commessa ben visibile + nome. Riga 2: cliente · sede dei lavori · chi esegue. */}
      {/* pv-testata / pv-info: sul telefono la testata va a capo (index.css), prima il nome si
          sovrapponeva ai pulsanti «⋯», «Personalizza», «Relazione» */}
      <div className="topbar pv-testata" style={{justifyContent:"flex-start",gap:12,flexWrap:"nowrap",overflowX:"auto",scrollbarWidth:"thin",height:"auto",minHeight:"var(--topbar-height)",padding:"8px 20px"}}>
        <div className="pv-testata-riga" style={{ display:"flex", alignItems:"center", gap:10, minWidth:0 }}>
          <div style={{ width:6, alignSelf:"stretch", minHeight:36, borderRadius:4, background: projectData?.color || "#7c3aed", flexShrink:0 }}/>
          <div className="pv-info" style={{minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:8}}>
              {projectData?.codiceCommessa && (
                <span title="Numero commessa" style={{fontFamily:"'Inter',sans-serif",fontWeight:800,color:"#fff",fontSize:13,letterSpacing:".02em",background:"#7c3aed",padding:"3px 10px",borderRadius:7,flexShrink:0,lineHeight:1.3}}>
                  {projectData.codiceCommessa}
                </span>
              )}
              <EditableProjectName projectId={projectId} name={projectData?.name || project?.name || ""} onRenamed={n=>setProjectData(p=>({...p,name:n}))}/>
              {/* N. ordine dell'azienda (W440): lo scrivono titolare, admin e responsabile */}
              {!projectData?.isParent && projectData && (
                <span style={{fontSize:12,flexShrink:0}}>
                  <NumeroOrdineCommessa projectId={projectId} valore={projectData?.numeroOrdine||""}
                    puoModificare={!!(isOrgAdmin||isPlatformOwner||(projectData?.responsabileUid && projectData.responsabileUid===currentUser?.uid))}
                    onSalvato={v=>setProjectData(p=>({...p,numeroOrdine:v}))}/>
                </span>
              )}
            </div>
            <div style={{display:"flex",alignItems:"center",flexWrap:"wrap",gap:"4px 14px",marginTop:4,fontSize:12}}>
              {projectData?.clienteNome && (
                <span style={{color:"#374151",fontWeight:600,whiteSpace:"nowrap"}}>👤 <ClienteLink cliente={{id:projectData.clienteId,ragioneSociale:projectData.clienteNome}}>{projectData.clienteNome}</ClienteLink></span>
              )}
              {!projectData?.isParent && !projectData?.senzaCliente && (sedeEffettiva.sede
                ? <span style={{whiteSpace:"nowrap"}} title={sedeEffettiva.implicita ? "Unica sede del cliente: vale come sede dei lavori" : undefined}><RigaSede sede={sedeEffettiva.sede}/>{(isOrgAdmin||isPlatformOwner) && <button onClick={()=>setShowPianoModal(true)} style={{marginLeft:6,border:"none",background:"none",color:"#7c3aed",fontSize:11.5,fontWeight:600,cursor:"pointer",padding:0,textDecoration:"underline"}}>cambia</button>}</span>
                : (isOrgAdmin||isPlatformOwner) && (
                  <button onClick={()=>setShowPianoModal(true)} title="Scegli la sede del cliente dove si svolgono i lavori"
                    style={{border:"1px dashed #a78bfa",background:"#f5f3ff",color:"#6d28d9",fontSize:11.5,fontWeight:700,borderRadius:7,padding:"2px 9px",cursor:"pointer",whiteSpace:"nowrap",fontFamily:"'Inter',sans-serif"}}>
                    📍 Indica la sede dei lavori
                  </button>
                )
              )}
              {!projectData?.isParent && leggiTipoEsecuzione(projectData)!=="interno" && (
                <span onClick={(isOrgAdmin||isPlatformOwner)?()=>setShowPianoModal(true):undefined} title={(isOrgAdmin||isPlatformOwner)?"Modifica chi esegue i lavori":undefined}
                  style={{color:"#0369a1",fontWeight:600,whiteSpace:"nowrap",cursor:(isOrgAdmin||isPlatformOwner)?"pointer":"default"}}>
                  🏗️ {descrizioneEsecuzione(projectData)}
                </span>
              )}
              {nomeCommessaOriginale && (
                <span style={{color:"#9ca3af",whiteSpace:"nowrap"}}>🔧 Manutenzione di: {nomeCommessaOriginale}</span>
              )}
            </div>
          </div>

          {/* Menu commessa (Chiudi/Riapri/Archivia/Condividi) — posizione fissa, non dipende dal numero di toggle */}
          {!projectData?.isParent && (
            <div style={{position:"relative"}}>
              <button ref={projectMenuBtnRef} onClick={()=>{
                  if (!showProjectMenu) {
                    const r = projectMenuBtnRef.current.getBoundingClientRect();
                    setPosizioneProjectMenu({ top: r.bottom+4, left: r.left });
                  }
                  setShowProjectMenu(v=>!v);
                }} title="Altre azioni sulla commessa"
                style={{display:"flex",alignItems:"center",justifyContent:"center",width:28,height:28,borderRadius:7,
                  border:"1px solid #e5e7eb",background:showProjectMenu?"#f3f4f6":"#fff",cursor:"pointer",fontSize:16,color:"#6b7280",flexShrink:0}}>
                ⋯
              </button>
              {showProjectMenu && posizioneProjectMenu && createPortal(
                <div ref={projectMenuRef} style={{position:"fixed",top:posizioneProjectMenu.top,left:posizioneProjectMenu.left,zIndex:1000,background:"#fff",border:"1px solid #e5e7eb",borderRadius:10,
                  boxShadow:"0 8px 24px rgba(0,0,0,.12)",padding:6,minWidth:180,display:"flex",flexDirection:"column",gap:2}}>
                  {isOrgAdmin && projectData?.statoCommessa !== "chiusa" && (
                    <button onClick={()=>{setShowChiudiModal(true);setShowProjectMenu(false);}}
                      style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"none",background:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,color:"#dc2626",textAlign:"left"}}>
                      🔒 Chiudi commessa
                    </button>
                  )}
                  {isOrgAdmin && projectData?.statoCommessa === "chiusa" && (
                    <button onClick={()=>{setShowRiapriModal(true);setShowProjectMenu(false);}}
                      style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"none",background:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,color:"#059669",textAlign:"left"}}>
                      🔓 Riapri commessa
                    </button>
                  )}
                  {isOrgAdmin && (
                    <button onClick={()=>{archiveProject();setShowProjectMenu(false);}}
                      style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"none",background:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,color:"#d97706",textAlign:"left"}}>
                      <Archive size={13}/> Archivia
                    </button>
                  )}
                  {(isOrgAdmin||isPlatformOwner||projectData?.responsabileUid===currentUser?.uid) && (
                    <button onClick={()=>{setShowRichiestaFatturazione(true);setShowProjectMenu(false);}}
                      style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"none",background:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,color:"#7c3aed",textAlign:"left"}}>
                      <FileText size={13}/> Richiedi Fatturazione
                    </button>
                  )}
                  {(isOrgAdmin||isPlatformOwner) && (
                    <button onClick={()=>{setShowPianoModal(true);setShowProjectMenu(false);}}
                      style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"none",background:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,color:"#374151",textAlign:"left"}}>
                      📊 Sede, piano di carico e imprese
                    </button>
                  )}
                  {!projectData?.cantiere && !commessaChiusa && (
                    <button onClick={()=>{setActiveTab("sicurezza");setShowProjectMenu(false);}}
                      style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"none",background:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,color:"#b91c1c",textAlign:"left"}}>
                      🦺 È un cantiere: attiva la sicurezza
                    </button>
                  )}
                  {puoGestireCommessa && (
                  <button onClick={()=>{setShowShare(true);setShowProjectMenu(false);}} title="Condividi la commessa con colleghi della tua azienda"
                    style={{display:"flex",alignItems:"center",gap:8,padding:"7px 10px",border:"none",background:"none",borderRadius:6,cursor:"pointer",fontSize:12,fontWeight:600,color:"#374151",textAlign:"left"}}>
                    <Share2 size={13}/> Condividi
                  </button>
                  )}
                </div>,
                document.body
              )}
            </div>
          )}

          {USA_MENU_UNIFICATO_COMMESSA && (
            <PersonalizzaCommessaMenu moduli={moduliCommessa} onToggle={m=>m.onToggle()}/>
          )}
          {!USA_MENU_UNIFICATO_COMMESSA && (<>
          {/* Toggle Controllo Economico — solo se modulo globale attivo */}
          {canToggleEconomico && controlloEconomicoGlobale && (
            <button onClick={toggleEconomico}
              title={economicoAbilitato ? "Disattiva Controllo Economico per questo progetto" : "Attiva Controllo Economico per questo progetto"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,border:`1px solid ${economicoAbilitato?"#7c3aed":"#e5e7eb"}`,background:economicoAbilitato?"#ede9fe":"#fff",color:economicoAbilitato?"#7c3aed":"#9ca3af",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📊 {economicoAbilitato?"Economico ON":"Economico OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !cronoprogrammaAbilitato;
                setCronoprogrammaAbilitato(nuovo);
                if(!nuovo && activeTab==="cronoprogramma") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{cronoprogrammaAbilitato:nuovo},{merge:true});
              }}
              title={cronoprogrammaAbilitato?"Disattiva Cronoprogramma":"Attiva Cronoprogramma"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${cronoprogrammaAbilitato?"#059669":"#e5e7eb"}`,
                background:cronoprogrammaAbilitato?"#d1fae5":"#fff",
                color:cronoprogrammaAbilitato?"#059669":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📅 {cronoprogrammaAbilitato?"Crono ON":"Crono OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !manutenzioneAbilitata;
                setManutenzioneAbilitata(nuovo);
                if(!nuovo && activeTab==="manutenzione") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{manutenzioneAbilitata:nuovo},{merge:true});
              }}
              title={manutenzioneAbilitata?"Disattiva Gestione Manutenzione":"Attiva Gestione Manutenzione"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${manutenzioneAbilitata?"#7c3aed":"#e5e7eb"}`,
                background:manutenzioneAbilitata?"#ede9fe":"#fff",
                color:manutenzioneAbilitata?"#7c3aed":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              🔧 {manutenzioneAbilitata?"Manutenzione ON":"Manutenzione OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !registroInterventiAbilitato;
                setRegistroInterventiAbilitato(nuovo);
                if(!nuovo && activeTab==="registro-interventi") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{registroInterventiAbilitato:nuovo},{merge:true});
              }}
              title={registroInterventiAbilitato?"Disattiva Registro Interventi":"Attiva Registro Interventi"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${registroInterventiAbilitato?"#059669":"#e5e7eb"}`,
                background:registroInterventiAbilitato?"#d1fae5":"#fff",
                color:registroInterventiAbilitato?"#059669":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📋 {registroInterventiAbilitato?"Registro interventi ON":"Registro interventi OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !ddtAbilitato;
                setDdtAbilitato(nuovo);
                if(!nuovo && activeTab==="ddt") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{ddtAbilitato:nuovo},{merge:true});
              }}
              title={ddtAbilitato?"Disattiva DDT Uscita":"Attiva DDT Uscita"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${ddtAbilitato?"#0369a1":"#e5e7eb"}`,
                background:ddtAbilitato?"#e0f2fe":"#fff",
                color:ddtAbilitato?"#0369a1":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📄 {ddtAbilitato?"DDT Usc. ON":"DDT Usc. OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !ddtIngressoAbilitato;
                setDdtIngressoAbilitato(nuovo);
                if(!nuovo && activeTab==="ddt-ingresso") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{ddtIngressoAbilitato:nuovo},{merge:true});
              }}
              title={ddtIngressoAbilitato?"Disattiva DDT Ingresso":"Attiva DDT Ingresso"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${ddtIngressoAbilitato?"#059669":"#e5e7eb"}`,
                background:ddtIngressoAbilitato?"#f0fdf4":"#fff",
                color:ddtIngressoAbilitato?"#059669":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📥 {ddtIngressoAbilitato?"DDT Ingr. ON":"DDT Ingr. OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !comunicazioniAbilitato;
                setComunicazioniAbilitato(nuovo);
                if(!nuovo && activeTab==="comunicazioni") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{comunicazioniAbilitato:nuovo},{merge:true});
              }}
              title={comunicazioniAbilitato?"Disattiva Corrispondenza":"Attiva Corrispondenza"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${comunicazioniAbilitato?"#7c3aed":"#e5e7eb"}`,
                background:comunicazioniAbilitato?"#f5f3ff":"#fff",
                color:comunicazioniAbilitato?"#7c3aed":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📨 {comunicazioniAbilitato?"Corrisp. ON":"Corrisp. OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !reportAbilitato;
                setReportAbilitato(nuovo);
                if(!nuovo && activeTab==="report") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{reportAbilitato:nuovo},{merge:true});
              }}
              title={reportAbilitato?"Disattiva Report":"Attiva Report"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${reportAbilitato?"#7c3aed":"#e5e7eb"}`,
                background:reportAbilitato?"#faf5ff":"#fff",
                color:reportAbilitato?"#7c3aed":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📊 {reportAbilitato?"Report ON":"Report OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !richiesteCommAbilitato;
                setRichiesteCommAbilitato(nuovo);
                if(!nuovo && activeTab==="richieste-commerciali") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{richiesteCommAbilitato:nuovo},{merge:true});
              }}
              title={richiesteCommAbilitato?"Disattiva Richieste Commerciali":"Attiva Richieste Commerciali"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${richiesteCommAbilitato?"#d97706":"#e5e7eb"}`,
                background:richiesteCommAbilitato?"#fef3c7":"#fff",
                color:richiesteCommAbilitato?"#d97706":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              💼 {richiesteCommAbilitato?"Comm. ON":"Comm. OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !salAbilitato;
                setSalAbilitato(nuovo);
                if(!nuovo && activeTab==="sal") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{salAbilitato:nuovo},{merge:true});
              }}
              title={salAbilitato?"Disattiva Computo Metrico / SAL":"Attiva Computo Metrico / SAL"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${salAbilitato?"#d97706":"#e5e7eb"}`,
                background:salAbilitato?"#fef3c7":"#fff",
                color:salAbilitato?"#d97706":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📐 SAL {salAbilitato?"ON":"OFF"}
            </button>
          )}
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !extraAbilitato;
                setExtraAbilitato(nuovo);
                if(!nuovo && activeTab==="extra") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{extraAbilitato:nuovo},{merge:true});
              }}
              title={extraAbilitato?"Disattiva Varianti e lavori extra":"Attiva Varianti e lavori extra"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${extraAbilitato?"#7c3aed":"#e5e7eb"}`,
                background:extraAbilitato?"#f5f3ff":"#fff",
                color:extraAbilitato?"#7c3aed":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              ➕ Varianti {extraAbilitato?"ON":"OFF"}
            </button>
          )}
          </>)}
          <button onClick={()=>setShowRelazioneFinale(true)}
            title={projectData?.statoCommessa==="chiusa" ? "Relazione Finale della Commessa — sintesi economica, avanzamento, attività, materiali e cliente" : "Relazione della Commessa — sintesi aggiornata a oggi, diventa definitiva alla chiusura"}
            style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
              border:"1px solid #e9d5ff", background:"#faf5ff", color:"#7c3aed",
              fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
            📋 {projectData?.statoCommessa==="chiusa" ? "Relazione Finale" : "Relazione"}
          </button>
          {/* Elementi fissi, spostati qui in riga 1 per lasciare la riga 2 tutta ai moduli
              attivabili — non cambiano mai in base a cosa attivi/disattivi. */}
          {isOrgAdmin && activeTab === "list" && !commessaChiusa && (
            <button className="btn btn-primary btn-sm" onClick={() => setShowNewSection(true)}
              style={{margin:"0",padding:"3px 10px",fontSize:12}}>
              <Plus size={12}/> Nuova sezione
            </button>
          )}
          <div style={{ position:"relative" }}>
            <button ref={addTabBtnRef} onClick={() => {
                if (!showAddTab) {
                  const r = addTabBtnRef.current.getBoundingClientRect();
                  setPosizioneAddTab({ top: r.bottom+4, left: r.left });
                }
                setShowAddTab(!showAddTab);
              }}
              style={{display:"flex",alignItems:"center",gap:4,padding:"3px 7px",borderRadius:7,border:"1px solid #e5e7eb",background:"#fff",color:"#9ca3af",fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif",flexShrink:0}}>
              <Plus size={13}/> Aggiungi vista
            </button>
            {showAddTab && posizioneAddTab && createPortal(
              <div ref={addTabRef} style={{ position:"fixed", top:posizioneAddTab.top, left:posizioneAddTab.left, background:"#fff", border:"1px solid #e5e7eb", borderRadius:8, boxShadow:"0 8px 24px rgba(0,0,0,0.12)", zIndex:1000, minWidth:160, padding:4 }}>
                {EXTRA_TABS.filter(t => !activeTabs.includes(t.id)).map(t => (
                  <button key={t.id} onClick={() => addTab(t.id)}
                    style={{ width:"100%", padding:"8px 12px", border:"none", background:"transparent", cursor:"pointer", textAlign:"left", fontSize:13, fontFamily:"'Inter',sans-serif", borderRadius:4 }}>
                    {t.label}
                  </button>
                ))}
                {EXTRA_TABS.every(t => activeTabs.includes(t.id)) && (
                  <div style={{ padding:"8px 12px", fontSize:12, color:"#9ca3af" }}>Tutte le viste aggiunte</div>
                )}
              </div>,
              document.body
            )}
          </div>
          {/* Viste di base — salite in riga 1 insieme agli elementi fissi, lasciando la
              riga 2 solo ai tab specifici di questa commessa. */}
          <div style={{width:1,background:"#e5e7eb",margin:"0 4px",alignSelf:"stretch"}}/>
          {activeTabs.map(tabId => (
            <button key={tabId} className={`project-tab ${activeTab === tabId ? "active" : ""}`}
              onClick={() => setActiveTab(tabId)}>
              {TAB_LABELS[tabId]}
            </button>
          ))}
          {!USA_MENU_UNIFICATO_COMMESSA && (<>
          {(isOrgAdmin||isPlatformOwner) && (
            <button onClick={async()=>{
                const nuovo = !giornaleAbilitato;
                setGiornaleAbilitato(nuovo);
                if(!nuovo && activeTab==="giornale") setActiveTab("list");
                await setDoc(doc(db,"projects",projectId),{giornaleAbilitato:nuovo},{merge:true});
              }}
              title={giornaleAbilitato?"Disattiva Giornale di Cantiere":"Attiva Giornale di Cantiere"}
              style={{display:"flex",alignItems:"center",gap:5,padding:"3px 7px",borderRadius:7,
                border:`1px solid ${giornaleAbilitato?"#2563eb":"#e5e7eb"}`,
                background:giornaleAbilitato?"#dbeafe":"#fff",
                color:giornaleAbilitato?"#2563eb":"#9ca3af",
                fontSize:12,fontWeight:600,cursor:"pointer",fontFamily:"'Inter',sans-serif"}}>
              📓 {giornaleAbilitato?"Giornale ON":"Giornale OFF"}
            </button>
          )}
          </>)}
        </div>
      </div>

      {/* Riga responsabile — sempre visibile sotto la topbar */}
      {(!projectData?.isParent) && (
        <div style={{display:"flex",alignItems:"center",gap:16,padding:"3px 16px 5px",borderBottom:"1px solid #f3f4f6",background:"#fafafa",flexWrap:"wrap",minHeight:26}}>
          {projectData?.responsabileNome ? (
            <div style={{fontSize:12,color:"#5b21b6",fontWeight:700,display:"flex",alignItems:"center",gap:4}}>
              👷 Resp: {projectData.responsabileNome}
            </div>
          ) : (
            <div style={{fontSize:12,color:"#dc2626",fontWeight:600}}>⚠️ Nessun responsabile assegnato</div>
          )}
          {projectData?.statoCommessa === "chiusa" && (
            <div style={{fontSize:12,color:"#dc2626",fontWeight:700,display:"flex",alignItems:"center",gap:4}}>
              🔒 CHIUSA
              {projectData?.dataChiusura && <span style={{fontWeight:400,color:"#9ca3af",fontSize:11}}>· {new Date(projectData.dataChiusura+"T00:00:00").toLocaleDateString("it-IT")}</span>}
            </div>
          )}
          {projectData?.statoCommessa !== "chiusa" && projectData?.dataFine && (() => {
            const oggi = new Date(); oggi.setHours(0,0,0,0);
            const consegna = new Date(projectData.dataFine+"T00:00:00");
            const giorni = Math.round((consegna - oggi) / 86400000);
            const inRitardo = giorni < 0;
            return (
              <div style={{fontSize:12,fontWeight:700,display:"flex",alignItems:"center",gap:4,
                color: inRitardo ? "#dc2626" : giorni<=7 ? "#d97706" : "#6b7280"}}>
                {inRitardo ? `⚠️ Consegna superata da ${Math.abs(giorni)}gg` : giorni===0 ? "📅 Consegna oggi" : `📅 ${giorni}gg alla consegna`}
              </div>
            );
          })()}
        </div>
      )}

      {commessaChiusa && (
        <div style={{background:"#fef2f2",borderBottom:"1px solid #fca5a5",padding:"8px 20px",display:"flex",alignItems:"center",gap:8,flexShrink:0}}>
          <span style={{fontSize:13}}>🔒</span>
          <span style={{fontSize:12,fontWeight:700,color:"#dc2626"}}>
            Commessa chiusa{projectData?.dataChiusura && ` il ${new Date(projectData.dataChiusura+"T00:00:00").toLocaleDateString("it-IT")}`} — sola consultazione.
          </span>
          <span style={{fontSize:12,color:"#991b1b"}}>Riapri la commessa (menu ⋯) per tornare a modificare Attività, Economico, Cronoprogramma e Giornale di Cantiere.</span>
        </div>
      )}

      <div className="project-tabs">
        {/* Riga 2 tab — ora solo i tab specifici di questa commessa (Cabina di Regia,
            Sopralluogo, Rapportini, Verbali, moduli attivabili...). Le viste di base
            (Elenco, Calendario, Dashboard, Gantt) sono salite in riga 1, insieme a
            Nuova sezione e Aggiungi vista. */}
        {/* Separatore visivo */}
        <div style={{width:1,background:"#e5e7eb",margin:"0 4px",alignSelf:"stretch"}}/>
        {puoVedereCabinaRegia && (
        <button className={`project-tab ${activeTab==="cabina-regia"?"active":""}`}
            onClick={()=>setActiveTab("cabina-regia")}
            style={{color:activeTab==="cabina-regia"?"#7c3aed":"#6b7280",borderBottom:activeTab==="cabina-regia"?"2px solid #7c3aed":"none",fontWeight:activeTab==="cabina-regia"?700:400}}>
          🎛️ Cabina di Regia
        </button>
        )}
        {/* ORDINE: Sopralluogo · Rapportini · Verbali · Materiali · Regole · Economico · Crono · Registro · Giornale · Membri · Timeline */}
        {richiesteCommAbilitato && (
          <button className={`project-tab ${activeTab==="richieste-commerciali"?"active":""}`}
              onClick={()=>setActiveTab("richieste-commerciali")}
              style={{color:activeTab==="richieste-commerciali"?"#d97706":"#6b7280",borderBottom:activeTab==="richieste-commerciali"?"2px solid #d97706":"none",fontWeight:activeTab==="richieste-commerciali"?700:400}}>
            💼 Commerciale
          </button>
        )}
        {salAbilitato && (
          <button className={`project-tab ${activeTab==="sal"?"active":""}`}
              onClick={()=>setActiveTab("sal")}
              style={{color:activeTab==="sal"?"#d97706":"#6b7280",borderBottom:activeTab==="sal"?"2px solid #d97706":"none",fontWeight:activeTab==="sal"?700:400}}>
            📐 SAL
          </button>
        )}
        {extraAbilitato && (
          <button className={`project-tab ${activeTab==="extra"?"active":""}`}
              onClick={()=>setActiveTab("extra")}
              style={{color:activeTab==="extra"?"#7c3aed":"#6b7280",borderBottom:activeTab==="extra"?"2px solid #7c3aed":"none",fontWeight:activeTab==="extra"?700:400}}>
            ➕ Varianti
          </button>
        )}
        <button className={`project-tab ${activeTab==="sopralluogo"?"active":""}`}
            onClick={()=>setActiveTab("sopralluogo")}
            style={{color:activeTab==="sopralluogo"?"#2563eb":"#6b7280",borderBottom:activeTab==="sopralluogo"?"2px solid #2563eb":"none",fontWeight:activeTab==="sopralluogo"?700:400}}>
          🔍 Sopralluogo
        </button>
        <button className={`project-tab ${activeTab==="rapportini"?"active":""}`}
            onClick={()=>setActiveTab("rapportini")}
            style={{color:activeTab==="rapportini"?"#7c3aed":"#6b7280",borderBottom:activeTab==="rapportini"?"2px solid #7c3aed":"none",fontWeight:activeTab==="rapportini"?700:400}}>
          📋 Rapportini
        </button>
        <button className={`project-tab ${activeTab==="pratiche"?"active":""}`}
            onClick={()=>setActiveTab("pratiche")}
            style={{color:activeTab==="pratiche"?"#7c3aed":"#6b7280",borderBottom:activeTab==="pratiche"?"2px solid #7c3aed":"none",fontWeight:activeTab==="pratiche"?700:400}}>
          🗂️ Pratiche
        </button>
        {/* La scheda Sicurezza c'è solo sulle commesse-cantiere (si attiva dal menu ⋯) */}
        {!projectData?.isParent && (projectData?.cantiere || activeTab==="sicurezza") && (
          <button className={`project-tab ${activeTab==="sicurezza"?"active":""}`}
              onClick={()=>setActiveTab("sicurezza")}
              style={{color:activeTab==="sicurezza"?"#b91c1c":"#6b7280",borderBottom:activeTab==="sicurezza"?"2px solid #b91c1c":"none",fontWeight:activeTab==="sicurezza"?700:400}}>
            🦺 Sicurezza
          </button>
        )}
        <button className={`project-tab ${activeTab==="verbali"?"active":""}`}
            onClick={()=>setActiveTab("verbali")}
            style={{color:activeTab==="verbali"?"#7c3aed":"#6b7280",borderBottom:activeTab==="verbali"?"2px solid #7c3aed":"none",fontWeight:activeTab==="verbali"?700:400}}>
          📄 Verbali
        </button>
        <button className={`project-tab ${activeTab==="materiali"?"active":""}`}
            onClick={()=>setActiveTab("materiali")}>
          📦 Richieste al magazzino
        </button>
        <button className={`project-tab ${activeTab==="richiedi-nf"?"active":""}`}
            onClick={()=>setActiveTab("richiedi-nf")}
            style={{color:activeTab==="richiedi-nf"?"#7c3aed":"#6b7280",borderBottom:activeTab==="richiedi-nf"?"2px solid #7c3aed":"none",fontWeight:activeTab==="richiedi-nf"?700:400}}>
          📋 Richiedi NF
        </button>
        <button className={`project-tab ${activeTab==="regole"?"active":""}`}
            onClick={()=>setActiveTab("regole")}
            style={{color:activeTab==="regole"?"#7c3aed":"#6b7280",borderBottom:activeTab==="regole"?"2px solid #7c3aed":"none",fontWeight:activeTab==="regole"?700:400}}>
          ⚡ Regole
        </button>
        {showEconomicoTab && (
          <button className={`project-tab ${activeTab==="economico"?"active":""}`}
            onClick={()=>setActiveTab("economico")}
            style={{color:activeTab==="economico"?"#7c3aed":"#6b7280",borderBottom:activeTab==="economico"?"2px solid #7c3aed":"none",fontWeight:activeTab==="economico"?700:400}}>
            📊 Economico
          </button>
        )}
        {cronoprogrammaAbilitato && (
          <button className={`project-tab ${activeTab==="cronoprogramma"?"active":""}`}
              onClick={()=>setActiveTab("cronoprogramma")}
              style={{color:activeTab==="cronoprogramma"?"#7c3aed":"#6b7280",borderBottom:activeTab==="cronoprogramma"?"2px solid #7c3aed":"none",fontWeight:activeTab==="cronoprogramma"?700:400}}>
            📅 Crono
          </button>
        )}
        {manutenzioneAbilitata && (
          <button className={`project-tab ${activeTab==="manutenzione"?"active":""}`}
              onClick={()=>setActiveTab("manutenzione")}
              style={{color:activeTab==="manutenzione"?"#7c3aed":"#6b7280",borderBottom:activeTab==="manutenzione"?"2px solid #7c3aed":"none",fontWeight:activeTab==="manutenzione"?700:400}}>
            🔧 Manutenzione
          </button>
        )}
        {registroInterventiAbilitato && (
          <button className={`project-tab ${activeTab==="registro-interventi"?"active":""}`}
              onClick={()=>setActiveTab("registro-interventi")}
              style={{color:activeTab==="registro-interventi"?"#059669":"#6b7280",borderBottom:activeTab==="registro-interventi"?"2px solid #059669":"none",fontWeight:activeTab==="registro-interventi"?700:400}}>
            📋 Registro interventi
          </button>
        )}
        {giornaleAbilitato && (
          <button className={`project-tab ${activeTab==="giornale"?"active":""}`}
              onClick={()=>setActiveTab("giornale")}
              style={{color:activeTab==="giornale"?"#2563eb":"#6b7280",borderBottom:activeTab==="giornale"?"2px solid #2563eb":"none",fontWeight:activeTab==="giornale"?700:400}}>
            📓 Giornale
          </button>
        )}
        {ordineCaviAbilitato && (
          <button className={`project-tab ${activeTab==="ordine-cavi"?"active":""}`}
              onClick={()=>setActiveTab("ordine-cavi")}
              style={{color:activeTab==="ordine-cavi"?"#6d28d9":"#6b7280",borderBottom:activeTab==="ordine-cavi"?"2px solid #6d28d9":"none",fontWeight:activeTab==="ordine-cavi"?700:400}}>
            🔀 Ordine Cavi
          </button>
        )}
        {ddtAbilitato && (
          <button className={`project-tab ${activeTab==="ddt"?"active":""}`}
              onClick={()=>setActiveTab("ddt")}
              style={{color:activeTab==="ddt"?"#0369a1":"#6b7280",borderBottom:activeTab==="ddt"?"2px solid #0369a1":"none",fontWeight:activeTab==="ddt"?700:400}}>
            📄 DDT Uscita
          </button>
        )}
        {ddtIngressoAbilitato && (
          <button className={`project-tab ${activeTab==="ddt-ingresso"?"active":""}`}
              onClick={()=>setActiveTab("ddt-ingresso")}
              style={{color:activeTab==="ddt-ingresso"?"#059669":"#6b7280",borderBottom:activeTab==="ddt-ingresso"?"2px solid #059669":"none",fontWeight:activeTab==="ddt-ingresso"?700:400}}>
            📥 DDT Ingresso
          </button>
        )}
        {comunicazioniAbilitato && (
          <button className={`project-tab ${activeTab==="comunicazioni"?"active":""}`}
              onClick={()=>setActiveTab("comunicazioni")}
              style={{color:activeTab==="comunicazioni"?"#7c3aed":"#6b7280",borderBottom:activeTab==="comunicazioni"?"2px solid #7c3aed":"none",fontWeight:activeTab==="comunicazioni"?700:400}}>
            📨 Corrispondenza
          </button>
        )}
        {reportAbilitato && (
          <button className={`project-tab ${activeTab==="report"?"active":""}`}
              onClick={()=>setActiveTab("report")}
              style={{color:activeTab==="report"?"#7c3aed":"#6b7280",borderBottom:activeTab==="report"?"2px solid #7c3aed":"none",fontWeight:activeTab==="report"?700:400}}>
            📊 Report Commessa
          </button>
        )}
        <button className={`project-tab ${activeTab==="membri"?"active":""}`}
            onClick={()=>setActiveTab("membri")}
            style={{color:activeTab==="membri"?"#7c3aed":"#6b7280",borderBottom:activeTab==="membri"?"2px solid #7c3aed":"none",fontWeight:activeTab==="membri"?700:400}}>
          👥 Membri
        </button>
        <button className={`project-tab ${activeTab==="timeline"?"active":""}`}
            onClick={()=>setActiveTab("timeline")}
            style={{color:activeTab==="timeline"?"#7c3aed":"#6b7280",borderBottom:activeTab==="timeline"?"2px solid #7c3aed":"none",fontWeight:activeTab==="timeline"?700:400}}>
          📡 Timeline
        </button>
      </div>

      {/* Barra di ricerca attività — visibile solo nella vista Elenco */}
      {activeTab === "list" && manutenzioneAbilitata && (
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,
          background:"#f4f0fc",border:"1px solid #ddd6fe",borderRadius:10,padding:"12px 16px",margin:"16px 16px 0"}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:16,flexShrink:0}}>🔧</span>
            <span style={{fontSize:12.5,color:"#5b21b6"}}>
              <strong>Questa è una commessa di manutenzione.</strong> Impianti, piani, interventi e — se c'è un contratto collegato — i ricavi si gestiscono dalla scheda dedicata, non da Elenco/Attività.
            </span>
          </div>
          <button onClick={()=>setActiveTab("manutenzione")}
            style={{flexShrink:0,padding:"7px 14px",borderRadius:7,border:"none",background:"#7c3aed",color:"#fff",
              fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif",whiteSpace:"nowrap"}}>
            Vai a Manutenzione →
          </button>
        </div>
      )}
      {activeTab === "list" && (
        <div style={{padding:"8px 16px",background:"#f9fafb",borderBottom:"1px solid #e5e7eb",display:"flex",alignItems:"center",gap:8}}>
          <div style={{position:"relative",flex:1,maxWidth:380}}>
            <input value={taskSearch} onChange={e=>setTaskSearch(e.target.value)}
              placeholder="🔍 Cerca attività o sezione..."
              style={{width:"100%",padding:"6px 30px 6px 12px",border:"1px solid #e5e7eb",borderRadius:8,
                fontSize:13,fontFamily:"'Inter',sans-serif",outline:"none",boxSizing:"border-box",background:"#fff"}}/>
            {taskSearch && (
              <button onClick={()=>setTaskSearch("")}
                style={{position:"absolute",right:8,top:"50%",transform:"translateY(-50%)",
                  background:"none",border:"none",cursor:"pointer",color:"#9ca3af",fontSize:16,lineHeight:1}}>×</button>
            )}
          </div>
          {taskSearch && <span style={{fontSize:12,color:"#9ca3af"}}>Filtrando per: "{taskSearch}"</span>}
          <div style={{flex:1}}/>
          <NoteCommessa projectId={projectId} projectName={projectData?.name||""} codiceCommessa={projectData?.codiceCommessa||""} orgId={organizationId} onNavigate={onNavigate}/>
        </div>
      )}

      {/* Schede della commessa che appartengono a un modulo Pro/Gold: sola lettura se il
          piano non lo include (i pulsanti di scrittura diventano inattivi). */}
      <ZonaModulo modulo={SCHEDA_MODULO[activeTab]}>
      <div className="content">
        {activeTab === "list" && (
          <ListView projectId={projectId} organizationId={organizationId} selectedTask={selectedTask} onSelectTask={setSelectedTask} onSelectSubtask={(t, st) => { setSelectedTask(t); setSelectedSubtask(st); }} taskSearch={taskSearch} soloMieAttività={soloMieAttività} currentUserUid={currentUser?.uid} commessaChiusa={commessaChiusa} dirittiCtx={dirittiCtx} puoRiordinare={mioRuolo!=="condiviso" || puoGestireCommessa}/>
        )}
        {activeTab === "board" && <ProjectKanban project={projectForChildren} onSelectTask={setSelectedTask} dirittiCtx={dirittiCtx} commessaChiusa={commessaChiusa}/>}
        {activeTab === "calendar" && <ProjectCalendar project={projectForChildren} onSelectTask={setSelectedTask}/>}
        {activeTab === "dashboard" && (
          <div style={{flex:1, overflowY:"auto", padding:"0 16px"}}>
            {manutenzioneAbilitata && (
              <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12,
                background:"#f4f0fc",border:"1px solid #ddd6fe",borderRadius:10,padding:"12px 16px",margin:"16px 0"}}>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:16,flexShrink:0}}>🔧</span>
                  <span style={{fontSize:12.5,color:"#5b21b6"}}>
                    <strong>Questa è una commessa di manutenzione.</strong> Impianti, piani, interventi e — se c'è un contratto collegato — i ricavi si gestiscono dalla scheda dedicata, non da Elenco/Attività.
                  </span>
                </div>
                <button onClick={()=>setActiveTab("manutenzione")}
                  style={{flexShrink:0,padding:"7px 14px",borderRadius:7,border:"none",background:"#7c3aed",color:"#fff",
                    fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:"'Inter',sans-serif",whiteSpace:"nowrap"}}>
                  Vai a Manutenzione →
                </button>
              </div>
            )}
            <RelazioniCommessaWidget projectId={projectId} orgId={organizationId}
              clienteId={projectData?.clienteId||""} clienteNome={projectData?.clienteNome||""}
              responsabileUid={projectData?.responsabileUid||""} responsabileNome={projectData?.responsabileNome||""}
              onNavigateTab={(tabId)=>setActiveTab(tabId)}/>
            <ProjectDashboard project={projectForChildren}/>
          </div>
        )}
        {activeTab === "gantt" && <ProjectGantt project={projectForChildren} onSelectTask={setSelectedTask}/>}
        {activeTab === "timeline" && <ProjectTimeline project={projectForChildren} onSelectTask={setSelectedTask}/>}
        {activeTab === "regole" && <RegoleProgetto projectId={project.id} orgId={project.organizationId || projectData?.organizationId} projectData={projectData}/>}
        {activeTab === "registro-interventi" && (
          <RegistroInterventi projectId={projectId}/>
        )}
        {activeTab === "comunicazioni" && (
          <ComunicazioniTab
            apriId={apriElemento?.tab==="comunicazioni"?apriElemento.id:null} onAperto={()=>setApriElemento(null)}
            projectId={projectId}
            projectName={projectData?.name || project?.name || ""}
            codiceCommessa={projectData?.codiceCommessa || ""}
            clienteNome={projectData?.clienteNome || ""}
            orgId={organizationId}
          />
        )}
        {activeTab === "report" && (
          <ReportCommessaTab
            projectId={projectId}
            projectData={projectData}
            orgId={organizationId}
          />
        )}
        {activeTab === "ddt-ingresso" && (
          <DDTIngressoTab
            projectId={projectId}
            projectName={projectData?.name || project?.name || ""}
            codiceCommessa={projectData?.codiceCommessa || ""}
            orgId={organizationId}
            commessaChiusa={commessaChiusa}
          />
        )}
        {activeTab === "ddt" && (
          <DDTTab
            projectId={projectId}
            projectName={projectData?.name || project?.name || ""}
            codiceCommessa={projectData?.codiceCommessa || ""}
            clienteNome={projectData?.clienteNome || ""}
            clienteId={projectData?.clienteId || ""}
            orgId={organizationId}
            commessaChiusa={commessaChiusa}
          />
        )}
        {activeTab === "richieste-commerciali" && (
          <RichiestaCommercialeTab
            projectId={projectId}
            projectName={projectData?.name || project?.name || ""}
            codiceCommessa={projectData?.codiceCommessa || ""}
            clienteNome={projectData?.clienteNome || ""}
            orgId={organizationId}
          />
        )}
        {activeTab === "sal" && (
          <ComputoSALTab
            projectId={projectId}
            projectName={projectData?.name || project?.name || ""}
            codiceCommessa={projectData?.codiceCommessa || ""}
            clienteNome={projectData?.clienteNome || ""}
            orgId={organizationId}
            responsabileNome={projectData?.responsabileNome || ""}
          />
        )}
        {activeTab === "extra" && (
          <AttivitaExtraTab projectId={projectId} orgId={organizationId} projectData={projectData}
            apriId={apriElemento?.tab==="extra"?apriElemento.id:null} onAperto={()=>setApriElemento(null)}/>
        )}
        {activeTab === "cabina-regia" && puoVedereCabinaRegia && (
          <CabinaDiRegiaTab projectId={projectId} projectData={projectData} orgId={organizationId}
            moduli={{ economico: showEconomicoTab, extra: extraAbilitato, sal: salAbilitato, cronoprogramma: cronoprogrammaAbilitato,
              comunicazioni: comunicazioniAbilitato, giornale: giornaleAbilitato }}
            mostraImporti={!!(canSeeEconomic || isPlatformOwner)}
            sedeEffettiva={sedeEffettiva}
            onVai={vaiDallaCabina}
            onApriTask={t=>setSelectedTask(t)}
            onNavigate={onNavigate}/>
        )}
        {activeTab === "sopralluogo" && (
          <SopralluogoTab
            projectId={projectId}
            projectName={projectData?.name || project?.name || ""}
            codiceCommessa={projectData?.codiceCommessa || ""}
            clienteNome={projectData?.clienteNome || ""}
            orgId={organizationId}
          />
        )}
        {activeTab === "giornale" && (
          <GiornaleCantiere
            projectId={projectId}
            orgId={organizationId}
            project={projectData || project}
            isAdmin={isOrgAdmin || isPlatformOwner}
            currentUser={currentUser}
          />
        )}
        {activeTab === "ordine-cavi" && (
          <OrdineCaviTab
            projectId={projectId}
            orgId={organizationId}
            projectNome={(projectData || project)?.name}
            codiceCommessa={(projectData || project)?.codiceCommessa}
            statoCommessa={(projectData || project)?.statoCommessa}
            isAdmin={isOrgAdmin || isPlatformOwner}
            currentUser={currentUser}
          />
        )}
        {activeTab === "cronoprogramma" && (
          <Cronoprogramma
            projectId={projectId}
            orgId={organizationId}
            project={projectData || project}
            isAdmin={isOrgAdmin || isPlatformOwner}
            currentUser={currentUser}
          />
        )}
        {activeTab === "manutenzione" && (
          <ManutenzioneTab
            projectId={projectId}
            orgId={organizationId}
            project={projectData || project}
            currentUser={currentUser}
          />
        )}
        {activeTab === "rapportini" && (
          <div style={{flex:1, overflowY:"auto"}}>
          <RapportiniTab projectId={projectId} projectName={projectData?.name||""} codiceCommessa={projectData?.codiceCommessa||""} orgId={organizationId}/>
          </div>
        )}
        {activeTab === "pratiche" && (
          <div style={{flex:1, overflowY:"auto"}}>
            <PraticheTab projectId={projectId} projectData={projectData}/>
          </div>
        )}
        {activeTab === "sicurezza" && (
          <div style={{flex:1, overflowY:"auto"}}>
            <SicurezzaCantiereTab projectId={projectId} projectData={projectData}/>
          </div>
        )}
        {activeTab === "verbali" && (
          <VerbaliCommessa projectId={projectId} orgId={organizationId} currentUserUid={currentUser?.uid} isAdmin={isOrgAdmin||isPlatformOwner}/>
        )}
        {activeTab === "membri" && (
          <MembriProgetto project={projectData} orgId={organizationId} currentUser={currentUser} isAdmin={isOrgAdmin||isPlatformOwner}/>
        )}
        {activeTab === "timeline" && (
          <TimelineProgetto projectId={projectId} orgId={organizationId}/>
        )}
        {activeTab === "materiali" && (
          <div style={{flex:1, overflowY:"auto"}}>
            <RichiestaMaterialiTab projectId={projectId} projectName={projectData?.name||""} orgId={organizationId} projectData={projectData} onNavigate={onNavigate}/>
          </div>
        )}
        {activeTab === "richiedi-nf" && (
          <div style={{flex:1, overflowY:"auto"}}>
            <RichiediNFTab projectId={projectId} projectName={projectData?.name||""} codiceCommessa={projectData?.codiceCommessa||""} orgId={organizationId} projectData={projectData}/>
          </div>
        )}
        {activeTab === "economico" && showEconomicoTab && (
          <div style={{flex:1, overflowY:"auto"}}>
            <ControlloEconomico
              projectId={projectId}
              projectData={projectData}
              clienteId={projectData?.clienteId||null}
              orgId={organizationId}
              onNavigate={onNavigate}
              onApriVarianti={async()=>{
                if (!extraAbilitato) {
                  if (!puoModuliEconomici) { addToast("Varianti e lavori extra non è attivo su questa commessa. Contatta l'Admin per farti abilitare","viola"); return; }
                  setExtraAbilitato(true);
                  await setDoc(doc(db,"projects",projectId),{extraAbilitato:true},{merge:true});
                }
                setActiveTab("extra");
              }}/>
          </div>
        )}

        {selectedTask && (
          <TaskDetailPanel task={selectedTask}
            onClose={() => { setSelectedTask(null); setSelectedSubtask(null); }}
            onUpdate={t => setSelectedTask(t)}
            onSelectSubtask={st => setSelectedSubtask(st)}
            selectedSubtaskId={selectedSubtask?.id}/>
        )}
        {selectedSubtask && (
          <SubtaskDetailPanel subtask={selectedSubtask}
            onClose={() => setSelectedSubtask(null)}
            onUpdated={st => setSelectedSubtask(st)}
            onDeleted={() => setSelectedSubtask(null)}/>
        )}
      </div>
      </ZonaModulo>

      {showNewSection && (
        <NewSectionModal projectId={projectId} onClose={() => setShowNewSection(false)}/>
      )}
      {showRelazioneFinale && (
        <RelazioneFinaleModal projectId={projectId} projectData={projectData} orgId={organizationId} onClose={()=>setShowRelazioneFinale(false)}/>
      )}
      {/* Modal valore economico */}


      {showChiudiModal && (
        <ChiudiCommessaModal
          projectId={projectId}
          projectData={projectData}
          organizationId={organizationId}
          currentUser={currentUser}
          onClose={() => setShowChiudiModal(false)}
          addToast={addToast}
        />
      )}
      {showRiapriModal && (
        <RiapriCommessaModal
          projectId={projectId}
          projectData={projectData}
          organizationId={organizationId}
          currentUser={currentUser}
          onClose={() => setShowRiapriModal(false)}
          addToast={addToast}
        />
      )}
      {showShare && (
        <ShareProjectModal projectId={projectId} projectName={projectData?.name || project?.name} organizationId={organizationId} onClose={() => setShowShare(false)}/>
      )}
      {showRichiestaFatturazione && (
        <RichiestaFatturazioneModal project={{ id:projectId, ...projectData }} orgId={organizationId} currentUser={currentUser} onClose={() => setShowRichiestaFatturazione(false)}/>
      )}
    </div>
  );
}
